/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * My API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgentActionApprovalExecutionResponse,
  AgentActionDecisionLedgerResponse,
  AgentAttachmentPresignResponse,
  AgentContextRequestAnswerRequest,
  AgentContextRequestAnswerResponse,
  AgentConversationTimelineResponse,
  AgentConversationsResponse,
  AgentCreateConversationResponse,
  AgentErrorResponse,
  AgentGetConversationResponse,
  AgentListPendingAsksResponse,
  AgentMultipartPlainTextTurnRequest,
  AgentRunEventsResponse,
  AgentRunSnapshot,
  AgentSendConversationMessageRequest,
  AgentSendConversationMessageResponse,
  AgentVoiceTranscriptionRequest,
  AgentVoiceTranscriptionResponse,
  AppendAgentRunMessageRequest,
  AppendAgentRunMessageResponse,
  BeginSearchRequest,
  Bucket,
  BucketContact,
  CandidateDuplicateErrorResponse,
  CandidateProfile,
  CandidateProfileResponse,
  CandidateTimelineItemV1,
  ChatbotJoinResponse,
  Comment,
  Company,
  Contact,
  ContactOutLinkedInCreateRequest,
  ContactOutLinkedInCreateResponse,
  CreateAgentConversationRequest,
  CreateAgentRunRequest,
  CreateEmailSignatureRequest,
  DeleteContactsHiringManagers200Item,
  DeleteContactsHiringManagersBody,
  DeleteFilesOwnerFileId200,
  DeleteJobsJobIdPipelineCommentsCommentId200,
  DeleteOrgObsUsersRevokeBody,
  Email,
  EmailSignature,
  EventCreate,
  EventUpdate,
  ExtractFiltersRequest,
  ExtractFiltersResponse,
  GetCandidates200,
  GetCandidatesCandidateIdJobs200Item,
  GetCandidatesCandidateIdTimelineParams,
  GetCandidatesParams,
  GetCandidatesSearch200Item,
  GetCandidatesSearchParams,
  GetCommentsParams,
  GetCompanies200,
  GetCompaniesJobContactCounts200,
  GetCompaniesJobContactCountsParams,
  GetContactsContactIdBuckets200Item,
  GetContactsParams,
  GetEmailsParams,
  GetEvents200,
  GetEventsBusySlots200,
  GetEventsBusySlotsParams,
  GetEventsParams,
  GetEventsProvider200,
  GetFilesOwnerFileIdPresign200,
  GetId200,
  GetJobsJobIdActivitiesParams,
  GetJobsJobIdCandidate200,
  GetJobsJobIdCandidateParams,
  GetJobsJobIdHiringManagers200Item,
  GetJobsJobIdPipeline200,
  GetJobsJobIdPipelineComments200Item,
  GetJobsParams,
  GetOrgObsList200Item,
  GetOrgObsRevenueParams,
  GetOrgObsUsers200Item,
  GetOutreach200,
  GetOutreachParams,
  GetPlacementsParams,
  GetSearch200Item,
  GetSearchEnrichProfilesCandidateId200,
  GetSearchEnrichProfilesCandidateIdParams,
  GetSearchKeywordsHash200,
  GetSearchLocationAutocomplete200,
  GetSearchLocationAutocompleteParams,
  GetSearchLocationResolve200,
  GetSearchLocationResolveParams,
  GetSearchQueries200,
  GetSearchQueriesParams,
  GetSearchResultsHash200,
  GetSearchResultsHashParams,
  GetSearchResultsHashProbe200,
  GetSearchResultsHashProbeParams,
  GetTasksParams,
  GetTouchpointsDue200Item,
  Job,
  JobActivity,
  JobCandidate,
  JobRisk,
  JobTask,
  PatchCandidatesCandidateIdBody,
  PatchCandidatesCandidateIdExperiencesBody,
  PatchJobsJobIdAssociateSearch200,
  PatchJobsJobIdAssociateSearchBody,
  PatchTasksTaskIdStatus200,
  PatchTasksTaskIdStatusBody,
  PlacementListResponse,
  PlacementRequest,
  PlacementResponse,
  PostAuthInvite200,
  PostAuthInviteBody,
  PostAuthLoginProviderStart200,
  PostAuthLoginProviderStartBody,
  PostAuthSetOrg200,
  PostAuthSetOrgBody,
  PostBucketsBody,
  PostBucketsContactsBody,
  PostCandidates200,
  PostCandidatesBody,
  PostCandidatesCandidateJobs200Item,
  PostCandidatesCandidateJobsBody,
  PostCandidatesParseResumeBody,
  PostCandidatesResume200,
  PostChatbotJoinBody,
  PostCommentsBody,
  PostCompaniesBody,
  PostContactfinderEnrichlayerRequestEmail200,
  PostContactfinderEnrichlayerRequestEmail202,
  PostContactfinderEnrichlayerRequestEmailBody,
  PostContactsBody,
  PostContactsCandidate201,
  PostContactsCandidateBody,
  PostContactsHiringManagers201,
  PostContactsHiringManagersBody,
  PostContactsUpsertBody,
  PostEmailsSendEmail200,
  PostEmailsSendEmailBody,
  PostEvents201,
  PostFilesOwnerOwnerId201,
  PostFilesOwnerOwnerIdBody,
  PostJobs201,
  PostJobsBody,
  PostJobsJobIdPipelineAdd201,
  PostJobsJobIdPipelineAdd207,
  PostJobsJobIdPipelineAddBody,
  PostJobsJobIdPipelineComments201,
  PostJobsJobIdPipelineCommentsBody,
  PostJobsPipelineJobCandidateIdFiles200,
  PostJobsPipelineJobCandidateIdFilesBody,
  PostSearchCount200,
  PostSearchFiltersEnrichBody,
  PostTasksBody,
  PostTouchpointsTouchpointIdApproveBody,
  PutBucketsBucketIdBody,
  PutCommentsCommentIdBody,
  PutCompaniesCompanyIdBody,
  PutContactsContactIdBody,
  PutFilesFileIdRename200,
  PutFilesFileIdRenameBody,
  PutJobsJobId201,
  PutJobsJobIdBody,
  PutJobsJobIdPipelineCommentsCommentId200,
  PutJobsJobIdPipelineCommentsCommentIdBody,
  PutJobsJobIdPipelineStage200,
  PutJobsJobIdPipelineStageBody,
  PutOrgObsUsersRoleBody,
  PutTasksTaskIdBody,
  RevenueDetailsResponse,
  StartAgentRunResponse,
  StructuredResumeCandidate,
  Task,
  UpdateEmailSignatureRequest,
  User
} from './model';

import { customClient } from '../mutator/custom-client';
import type { ErrorType , BodyType } from '../mutator/custom-client';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const agentMultipartPlainTextTurnRequestFormData = (
    body: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>| AgentMultipartPlainTextTurnRequest,
) => {
      if (!body || typeof body !== 'object' || !('files' in body)) return null
      const multipartBody = body as AgentMultipartPlainTextTurnRequest;
      if (!Array.isArray(multipartBody.files)) return null

      const formData = new FormData();
if(multipartBody.kind !== undefined) {
 formData.append(`kind`, multipartBody.kind)
 } else {
 formData.append(`kind`, `plain_text`)
 }
if(multipartBody.body !== undefined) {
 formData.append(`body`, multipartBody.body)
 } else {
 formData.append(`body`, ``)
 }
multipartBody.files.forEach((file) => {
 formData.append(`files`, file)
 })

      return formData;
    }



/**
 * @summary List private agent conversations for the authenticated user
 */
export const listAgentConversations = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AgentConversationsResponse>(
      {url: `/agents/conversations`, method: 'GET', signal
    },
      options);
    }
  



export const getListAgentConversationsQueryKey = () => {
    return [
    `/agents/conversations`
    ] as const;
    }

    
export const getListAgentConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listAgentConversations>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentConversations>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgentConversationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentConversations>>> = ({ signal }) => listAgentConversations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgentConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAgentConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgentConversations>>>
export type ListAgentConversationsQueryError = ErrorType<void>


export function useListAgentConversations<TData = Awaited<ReturnType<typeof listAgentConversations>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentConversations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentConversations>>,
          TError,
          Awaited<ReturnType<typeof listAgentConversations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAgentConversations<TData = Awaited<ReturnType<typeof listAgentConversations>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentConversations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentConversations>>,
          TError,
          Awaited<ReturnType<typeof listAgentConversations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAgentConversations<TData = Awaited<ReturnType<typeof listAgentConversations>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentConversations>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List private agent conversations for the authenticated user
 */

export function useListAgentConversations<TData = Awaited<ReturnType<typeof listAgentConversations>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentConversations>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAgentConversationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a private agent conversation
 */
export const createAgentConversation = (
    createAgentConversationRequest?: BodyType<CreateAgentConversationRequest>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AgentCreateConversationResponse>(
      {url: `/agents/conversations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAgentConversationRequest, signal
    },
      options);
    }
  


export const getCreateAgentConversationMutationOptions = <TError = ErrorType<AgentErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgentConversation>>, TError,{data: BodyType<CreateAgentConversationRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createAgentConversation>>, TError,{data: BodyType<CreateAgentConversationRequest>}, TContext> => {

const mutationKey = ['createAgentConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAgentConversation>>, {data: BodyType<CreateAgentConversationRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createAgentConversation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAgentConversationMutationResult = NonNullable<Awaited<ReturnType<typeof createAgentConversation>>>
    export type CreateAgentConversationMutationBody = BodyType<CreateAgentConversationRequest>
    export type CreateAgentConversationMutationError = ErrorType<AgentErrorResponse | void>

    /**
 * @summary Create a private agent conversation
 */
export const useCreateAgentConversation = <TError = ErrorType<AgentErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgentConversation>>, TError,{data: BodyType<CreateAgentConversationRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAgentConversation>>,
        TError,
        {data: BodyType<CreateAgentConversationRequest>},
        TContext
      > => {

      const mutationOptions = getCreateAgentConversationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Read a private agent conversation
 */
export const getAgentConversation = (
    conversationId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AgentGetConversationResponse>(
      {url: `/agents/conversations/${conversationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAgentConversationQueryKey = (conversationId?: string,) => {
    return [
    `/agents/conversations/${conversationId}`
    ] as const;
    }

    
export const getGetAgentConversationQueryOptions = <TData = Awaited<ReturnType<typeof getAgentConversation>>, TError = ErrorType<AgentErrorResponse>>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConversation>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentConversationQueryKey(conversationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentConversation>>> = ({ signal }) => getAgentConversation(conversationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(conversationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentConversation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAgentConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentConversation>>>
export type GetAgentConversationQueryError = ErrorType<AgentErrorResponse>


export function useGetAgentConversation<TData = Awaited<ReturnType<typeof getAgentConversation>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConversation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentConversation>>,
          TError,
          Awaited<ReturnType<typeof getAgentConversation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgentConversation<TData = Awaited<ReturnType<typeof getAgentConversation>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConversation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentConversation>>,
          TError,
          Awaited<ReturnType<typeof getAgentConversation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgentConversation<TData = Awaited<ReturnType<typeof getAgentConversation>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConversation>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a private agent conversation
 */

export function useGetAgentConversation<TData = Awaited<ReturnType<typeof getAgentConversation>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConversation>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAgentConversationQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns a short-lived download URL for a durable Agent chat attachment owned by the authenticated user. Raw S3 storage paths stay backend-only.
 * @summary Get a presigned URL for an uploaded Agent chat attachment
 */
export const presignAgentConversationAttachment = (
    conversationId: string,
    attachmentId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<AgentAttachmentPresignResponse>(
      {url: `/agents/conversations/${conversationId}/attachments/${attachmentId}/presign`, method: 'GET', signal
    },
      options);
    }




export const getPresignAgentConversationAttachmentQueryKey = (conversationId?: string,
    attachmentId?: string,) => {
    return [
    `/agents/conversations/${conversationId}/attachments/${attachmentId}/presign`
    ] as const;
    }


export const getPresignAgentConversationAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof presignAgentConversationAttachment>>, TError = ErrorType<AgentErrorResponse>>(conversationId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof presignAgentConversationAttachment>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPresignAgentConversationAttachmentQueryKey(conversationId,attachmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof presignAgentConversationAttachment>>> = ({ signal }) => presignAgentConversationAttachment(conversationId,attachmentId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(conversationId && attachmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof presignAgentConversationAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PresignAgentConversationAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof presignAgentConversationAttachment>>>
export type PresignAgentConversationAttachmentQueryError = ErrorType<AgentErrorResponse>


export function usePresignAgentConversationAttachment<TData = Awaited<ReturnType<typeof presignAgentConversationAttachment>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string,
    attachmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof presignAgentConversationAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof presignAgentConversationAttachment>>,
          TError,
          Awaited<ReturnType<typeof presignAgentConversationAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePresignAgentConversationAttachment<TData = Awaited<ReturnType<typeof presignAgentConversationAttachment>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof presignAgentConversationAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof presignAgentConversationAttachment>>,
          TError,
          Awaited<ReturnType<typeof presignAgentConversationAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePresignAgentConversationAttachment<TData = Awaited<ReturnType<typeof presignAgentConversationAttachment>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof presignAgentConversationAttachment>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a presigned URL for an uploaded Agent chat attachment
 */

export function usePresignAgentConversationAttachment<TData = Awaited<ReturnType<typeof presignAgentConversationAttachment>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof presignAgentConversationAttachment>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPresignAgentConversationAttachmentQueryOptions(conversationId,attachmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns reload-safe ask-user cards that can be answered with an ask_user_response turn.
 * @summary List pending ask-user cards for an agent conversation
 */
export const listAgentConversationPendingAsks = (
    conversationId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AgentListPendingAsksResponse>(
      {url: `/agents/conversations/${conversationId}/pending-asks`, method: 'GET', signal
    },
      options);
    }
  



export const getListAgentConversationPendingAsksQueryKey = (conversationId?: string,) => {
    return [
    `/agents/conversations/${conversationId}/pending-asks`
    ] as const;
    }

    
export const getListAgentConversationPendingAsksQueryOptions = <TData = Awaited<ReturnType<typeof listAgentConversationPendingAsks>>, TError = ErrorType<AgentErrorResponse>>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentConversationPendingAsks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgentConversationPendingAsksQueryKey(conversationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentConversationPendingAsks>>> = ({ signal }) => listAgentConversationPendingAsks(conversationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(conversationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgentConversationPendingAsks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAgentConversationPendingAsksQueryResult = NonNullable<Awaited<ReturnType<typeof listAgentConversationPendingAsks>>>
export type ListAgentConversationPendingAsksQueryError = ErrorType<AgentErrorResponse>


export function useListAgentConversationPendingAsks<TData = Awaited<ReturnType<typeof listAgentConversationPendingAsks>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentConversationPendingAsks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentConversationPendingAsks>>,
          TError,
          Awaited<ReturnType<typeof listAgentConversationPendingAsks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAgentConversationPendingAsks<TData = Awaited<ReturnType<typeof listAgentConversationPendingAsks>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentConversationPendingAsks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentConversationPendingAsks>>,
          TError,
          Awaited<ReturnType<typeof listAgentConversationPendingAsks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAgentConversationPendingAsks<TData = Awaited<ReturnType<typeof listAgentConversationPendingAsks>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentConversationPendingAsks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List pending ask-user cards for an agent conversation
 */

export function useListAgentConversationPendingAsks<TData = Awaited<ReturnType<typeof listAgentConversationPendingAsks>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentConversationPendingAsks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAgentConversationPendingAsksQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * The frontend should render conversation history from this projection instead of locally merging messages, events, actions, and receipts.
 * @summary Read backend-owned conversation timeline items in render order
 */
export const getAgentConversationTimeline = (
    conversationId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AgentConversationTimelineResponse>(
      {url: `/agents/conversations/${conversationId}/timeline`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAgentConversationTimelineQueryKey = (conversationId?: string,) => {
    return [
    `/agents/conversations/${conversationId}/timeline`
    ] as const;
    }

    
export const getGetAgentConversationTimelineQueryOptions = <TData = Awaited<ReturnType<typeof getAgentConversationTimeline>>, TError = ErrorType<AgentErrorResponse>>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConversationTimeline>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentConversationTimelineQueryKey(conversationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentConversationTimeline>>> = ({ signal }) => getAgentConversationTimeline(conversationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(conversationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentConversationTimeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAgentConversationTimelineQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentConversationTimeline>>>
export type GetAgentConversationTimelineQueryError = ErrorType<AgentErrorResponse>


export function useGetAgentConversationTimeline<TData = Awaited<ReturnType<typeof getAgentConversationTimeline>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConversationTimeline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentConversationTimeline>>,
          TError,
          Awaited<ReturnType<typeof getAgentConversationTimeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgentConversationTimeline<TData = Awaited<ReturnType<typeof getAgentConversationTimeline>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConversationTimeline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentConversationTimeline>>,
          TError,
          Awaited<ReturnType<typeof getAgentConversationTimeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgentConversationTimeline<TData = Awaited<ReturnType<typeof getAgentConversationTimeline>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConversationTimeline>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read backend-owned conversation timeline items in render order
 */

export function useGetAgentConversationTimeline<TData = Awaited<ReturnType<typeof getAgentConversationTimeline>>, TError = ErrorType<AgentErrorResponse>>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConversationTimeline>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAgentConversationTimelineQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Fallback JSON endpoint for the live conversation turn contract. The normal chat UI uses the streaming endpoint.
 * @summary Send a user turn to an agent conversation
 */
export const sendAgentConversationMessage = (
    conversationId: string,
    sendAgentConversationMessageBody: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>| AgentMultipartPlainTextTurnRequest,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      const formData = agentMultipartPlainTextTurnRequestFormData(sendAgentConversationMessageBody);
      
      return customClient<AgentSendConversationMessageResponse>(
      {url: `/agents/conversations/${conversationId}/messages`, method: 'POST',
      ...(formData ? {headers: {'Content-Type': 'multipart/form-data', }, } : {}),
      data: formData ?? sendAgentConversationMessageBody, signal
    },
      options);
    }
  


export const getSendAgentConversationMessageMutationOptions = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAgentConversationMessage>>, TError,{conversationId: string;data: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof sendAgentConversationMessage>>, TError,{conversationId: string;data: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>}, TContext> => {

const mutationKey = ['sendAgentConversationMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAgentConversationMessage>>, {conversationId: string;data: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  sendAgentConversationMessage(conversationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendAgentConversationMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendAgentConversationMessage>>>
    export type SendAgentConversationMessageMutationBody = BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>
    export type SendAgentConversationMessageMutationError = ErrorType<AgentErrorResponse>

    /**
 * @summary Send a user turn to an agent conversation
 */
export const useSendAgentConversationMessage = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAgentConversationMessage>>, TError,{conversationId: string;data: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendAgentConversationMessage>>,
        TError,
        {conversationId: string;data: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>},
        TContext
      > => {

      const mutationOptions = getSendAgentConversationMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Successful streams use named SSE events. Validation and stale ask failures return JSON before SSE starts.
 * @summary Send a user turn and stream agent progress events
 */
export const streamAgentConversationMessage = (
    conversationId: string,
    streamAgentConversationMessageBody: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>| AgentMultipartPlainTextTurnRequest,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      const formData = agentMultipartPlainTextTurnRequestFormData(streamAgentConversationMessageBody);
      
      return customClient<string>(
      {url: `/agents/conversations/${conversationId}/messages/stream`, method: 'POST',
      ...(formData ? {headers: {'Content-Type': 'multipart/form-data', }, } : {}),
      data: formData ?? streamAgentConversationMessageBody, signal
    },
      options);
    }
  


export const getStreamAgentConversationMessageMutationOptions = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof streamAgentConversationMessage>>, TError,{conversationId: string;data: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof streamAgentConversationMessage>>, TError,{conversationId: string;data: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>}, TContext> => {

const mutationKey = ['streamAgentConversationMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof streamAgentConversationMessage>>, {conversationId: string;data: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  streamAgentConversationMessage(conversationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StreamAgentConversationMessageMutationResult = NonNullable<Awaited<ReturnType<typeof streamAgentConversationMessage>>>
    export type StreamAgentConversationMessageMutationBody = BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>
    export type StreamAgentConversationMessageMutationError = ErrorType<AgentErrorResponse>

    /**
 * @summary Send a user turn and stream agent progress events
 */
export const useStreamAgentConversationMessage = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof streamAgentConversationMessage>>, TError,{conversationId: string;data: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof streamAgentConversationMessage>>,
        TError,
        {conversationId: string;data: BodyType<AgentSendConversationMessageRequest | AgentMultipartPlainTextTurnRequest>},
        TContext
      > => {

      const mutationOptions = getStreamAgentConversationMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Converts one recruiter voice recording into text for the composer. This endpoint does not create an Agent message or bypass confirmation flows.
 * @summary Transcribe Robin voice input
 */
export const transcribeAgentVoice = (
    agentVoiceTranscriptionRequest: BodyType<AgentVoiceTranscriptionRequest>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`audio`, agentVoiceTranscriptionRequest.audio)
if(agentVoiceTranscriptionRequest.language !== undefined) {
 formData.append(`language`, agentVoiceTranscriptionRequest.language)
 }

      return customClient<AgentVoiceTranscriptionResponse>(
      {url: `/agents/voice/transcriptions`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }



export const getTranscribeAgentVoiceMutationOptions = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transcribeAgentVoice>>, TError,{data: BodyType<AgentVoiceTranscriptionRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof transcribeAgentVoice>>, TError,{data: BodyType<AgentVoiceTranscriptionRequest>}, TContext> => {

const mutationKey = ['transcribeAgentVoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transcribeAgentVoice>>, {data: BodyType<AgentVoiceTranscriptionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  transcribeAgentVoice(data,requestOptions)
        }




  return  { mutationFn, ...mutationOptions }}

    export type TranscribeAgentVoiceMutationResult = NonNullable<Awaited<ReturnType<typeof transcribeAgentVoice>>>
    export type TranscribeAgentVoiceMutationBody = BodyType<AgentVoiceTranscriptionRequest>
    export type TranscribeAgentVoiceMutationError = ErrorType<AgentErrorResponse>

    /**
 * @summary Transcribe Robin voice input
 */
export const useTranscribeAgentVoice = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transcribeAgentVoice>>, TError,{data: BodyType<AgentVoiceTranscriptionRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof transcribeAgentVoice>>,
        TError,
        {data: BodyType<AgentVoiceTranscriptionRequest>},
        TContext
      > => {

      const mutationOptions = getTranscribeAgentVoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Creates a run ledger entry and initial user message, then synchronously invokes the planner for the first candidate-note slice.
 * @summary Start an Agentic ATS run
 */
export const startAgentRun = (
    createAgentRunRequest: BodyType<CreateAgentRunRequest>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<StartAgentRunResponse>(
      {url: `/agents/runs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAgentRunRequest, signal
    },
      options);
    }
  


export const getStartAgentRunMutationOptions = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startAgentRun>>, TError,{data: BodyType<CreateAgentRunRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof startAgentRun>>, TError,{data: BodyType<CreateAgentRunRequest>}, TContext> => {

const mutationKey = ['startAgentRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startAgentRun>>, {data: BodyType<CreateAgentRunRequest>}> = (props) => {
          const {data} = props ?? {};

          return  startAgentRun(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartAgentRunMutationResult = NonNullable<Awaited<ReturnType<typeof startAgentRun>>>
    export type StartAgentRunMutationBody = BodyType<CreateAgentRunRequest>
    export type StartAgentRunMutationError = ErrorType<AgentErrorResponse>

    /**
 * @summary Start an Agentic ATS run
 */
export const useStartAgentRun = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startAgentRun>>, TError,{data: BodyType<CreateAgentRunRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startAgentRun>>,
        TError,
        {data: BodyType<CreateAgentRunRequest>},
        TContext
      > => {

      const mutationOptions = getStartAgentRunMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Read an Agentic ATS run ledger
 */
export const getAgentRun = (
    runId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AgentRunSnapshot>(
      {url: `/agents/runs/${runId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAgentRunQueryKey = (runId?: string,) => {
    return [
    `/agents/runs/${runId}`
    ] as const;
    }

    
export const getGetAgentRunQueryOptions = <TData = Awaited<ReturnType<typeof getAgentRun>>, TError = ErrorType<AgentErrorResponse>>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentRun>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentRunQueryKey(runId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentRun>>> = ({ signal }) => getAgentRun(runId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(runId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentRun>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAgentRunQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentRun>>>
export type GetAgentRunQueryError = ErrorType<AgentErrorResponse>


export function useGetAgentRun<TData = Awaited<ReturnType<typeof getAgentRun>>, TError = ErrorType<AgentErrorResponse>>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentRun>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentRun>>,
          TError,
          Awaited<ReturnType<typeof getAgentRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgentRun<TData = Awaited<ReturnType<typeof getAgentRun>>, TError = ErrorType<AgentErrorResponse>>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentRun>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentRun>>,
          TError,
          Awaited<ReturnType<typeof getAgentRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgentRun<TData = Awaited<ReturnType<typeof getAgentRun>>, TError = ErrorType<AgentErrorResponse>>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentRun>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read an Agentic ATS run ledger
 */

export function useGetAgentRun<TData = Awaited<ReturnType<typeof getAgentRun>>, TError = ErrorType<AgentErrorResponse>>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentRun>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAgentRunQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Replay persisted run events in order
 */
export const getAgentRunEvents = (
    runId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AgentRunEventsResponse>(
      {url: `/agents/runs/${runId}/events`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAgentRunEventsQueryKey = (runId?: string,) => {
    return [
    `/agents/runs/${runId}/events`
    ] as const;
    }

    
export const getGetAgentRunEventsQueryOptions = <TData = Awaited<ReturnType<typeof getAgentRunEvents>>, TError = ErrorType<AgentErrorResponse>>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentRunEvents>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentRunEventsQueryKey(runId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentRunEvents>>> = ({ signal }) => getAgentRunEvents(runId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(runId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentRunEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAgentRunEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentRunEvents>>>
export type GetAgentRunEventsQueryError = ErrorType<AgentErrorResponse>


export function useGetAgentRunEvents<TData = Awaited<ReturnType<typeof getAgentRunEvents>>, TError = ErrorType<AgentErrorResponse>>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentRunEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentRunEvents>>,
          TError,
          Awaited<ReturnType<typeof getAgentRunEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgentRunEvents<TData = Awaited<ReturnType<typeof getAgentRunEvents>>, TError = ErrorType<AgentErrorResponse>>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentRunEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentRunEvents>>,
          TError,
          Awaited<ReturnType<typeof getAgentRunEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgentRunEvents<TData = Awaited<ReturnType<typeof getAgentRunEvents>>, TError = ErrorType<AgentErrorResponse>>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentRunEvents>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Replay persisted run events in order
 */

export function useGetAgentRunEvents<TData = Awaited<ReturnType<typeof getAgentRunEvents>>, TError = ErrorType<AgentErrorResponse>>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentRunEvents>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAgentRunEventsQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * If an active context request exists, the backend interprets the message as a possible answer before creating unrelated work.
 * @summary Append a user message to an existing run ledger
 */
export const appendAgentRunMessage = (
    runId: string,
    appendAgentRunMessageRequest: BodyType<AppendAgentRunMessageRequest>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AppendAgentRunMessageResponse>(
      {url: `/agents/runs/${runId}/messages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: appendAgentRunMessageRequest, signal
    },
      options);
    }
  


export const getAppendAgentRunMessageMutationOptions = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appendAgentRunMessage>>, TError,{runId: string;data: BodyType<AppendAgentRunMessageRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appendAgentRunMessage>>, TError,{runId: string;data: BodyType<AppendAgentRunMessageRequest>}, TContext> => {

const mutationKey = ['appendAgentRunMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appendAgentRunMessage>>, {runId: string;data: BodyType<AppendAgentRunMessageRequest>}> = (props) => {
          const {runId,data} = props ?? {};

          return  appendAgentRunMessage(runId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppendAgentRunMessageMutationResult = NonNullable<Awaited<ReturnType<typeof appendAgentRunMessage>>>
    export type AppendAgentRunMessageMutationBody = BodyType<AppendAgentRunMessageRequest>
    export type AppendAgentRunMessageMutationError = ErrorType<AgentErrorResponse>

    /**
 * @summary Append a user message to an existing run ledger
 */
export const useAppendAgentRunMessage = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appendAgentRunMessage>>, TError,{runId: string;data: BodyType<AppendAgentRunMessageRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appendAgentRunMessage>>,
        TError,
        {runId: string;data: BodyType<AppendAgentRunMessageRequest>},
        TContext
      > => {

      const mutationOptions = getAppendAgentRunMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Card selections submit explicit option IDs. Plain-chat replies should usually go through the message endpoint so the backend can interpret them against the active request.
 * @summary Store an answer to a pending context request
 */
export const answerAgentContextRequest = (
    runId: string,
    contextRequestId: string,
    agentContextRequestAnswerRequest: BodyType<AgentContextRequestAnswerRequest>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AgentContextRequestAnswerResponse>(
      {url: `/agents/runs/${runId}/context-requests/${contextRequestId}/answer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: agentContextRequestAnswerRequest, signal
    },
      options);
    }
  


export const getAnswerAgentContextRequestMutationOptions = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof answerAgentContextRequest>>, TError,{runId: string;contextRequestId: string;data: BodyType<AgentContextRequestAnswerRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof answerAgentContextRequest>>, TError,{runId: string;contextRequestId: string;data: BodyType<AgentContextRequestAnswerRequest>}, TContext> => {

const mutationKey = ['answerAgentContextRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof answerAgentContextRequest>>, {runId: string;contextRequestId: string;data: BodyType<AgentContextRequestAnswerRequest>}> = (props) => {
          const {runId,contextRequestId,data} = props ?? {};

          return  answerAgentContextRequest(runId,contextRequestId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AnswerAgentContextRequestMutationResult = NonNullable<Awaited<ReturnType<typeof answerAgentContextRequest>>>
    export type AnswerAgentContextRequestMutationBody = BodyType<AgentContextRequestAnswerRequest>
    export type AnswerAgentContextRequestMutationError = ErrorType<AgentErrorResponse>

    /**
 * @summary Store an answer to a pending context request
 */
export const useAnswerAgentContextRequest = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof answerAgentContextRequest>>, TError,{runId: string;contextRequestId: string;data: BodyType<AgentContextRequestAnswerRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof answerAgentContextRequest>>,
        TError,
        {runId: string;contextRequestId: string;data: BodyType<AgentContextRequestAnswerRequest>},
        TContext
      > => {

      const mutationOptions = getAnswerAgentContextRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Records the approval decision, executes the approved action through the backend execution kernel, then reloads the run snapshot.
 * @summary Approve a proposed Agentic ATS action
 */
export const approveAgentAction = (
    actionId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AgentActionApprovalExecutionResponse>(
      {url: `/agents/actions/${actionId}/approve`, method: 'POST', signal
    },
      options);
    }
  


export const getApproveAgentActionMutationOptions = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAgentAction>>, TError,{actionId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof approveAgentAction>>, TError,{actionId: string}, TContext> => {

const mutationKey = ['approveAgentAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAgentAction>>, {actionId: string}> = (props) => {
          const {actionId} = props ?? {};

          return  approveAgentAction(actionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveAgentActionMutationResult = NonNullable<Awaited<ReturnType<typeof approveAgentAction>>>
    
    export type ApproveAgentActionMutationError = ErrorType<AgentErrorResponse>

    /**
 * @summary Approve a proposed Agentic ATS action
 */
export const useApproveAgentAction = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAgentAction>>, TError,{actionId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveAgentAction>>,
        TError,
        {actionId: string},
        TContext
      > => {

      const mutationOptions = getApproveAgentActionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Records the rejection decision without executing the action.
 * @summary Reject a proposed Agentic ATS action
 */
export const rejectAgentAction = (
    actionId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AgentActionDecisionLedgerResponse>(
      {url: `/agents/actions/${actionId}/reject`, method: 'POST', signal
    },
      options);
    }
  


export const getRejectAgentActionMutationOptions = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAgentAction>>, TError,{actionId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectAgentAction>>, TError,{actionId: string}, TContext> => {

const mutationKey = ['rejectAgentAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectAgentAction>>, {actionId: string}> = (props) => {
          const {actionId} = props ?? {};

          return  rejectAgentAction(actionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectAgentActionMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAgentAction>>>
    
    export type RejectAgentActionMutationError = ErrorType<AgentErrorResponse>

    /**
 * @summary Reject a proposed Agentic ATS action
 */
export const useRejectAgentAction = <TError = ErrorType<AgentErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAgentAction>>, TError,{actionId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectAgentAction>>,
        TError,
        {actionId: string},
        TContext
      > => {

      const mutationOptions = getRejectAgentActionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get the currently authenticated user
 */
export const getAuthUser = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<User>(
      {url: `/auth/user`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAuthUserQueryKey = () => {
    return [
    `/auth/user`
    ] as const;
    }

    
export const getGetAuthUserQueryOptions = <TData = Awaited<ReturnType<typeof getAuthUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthUser>>> = ({ signal }) => getAuthUser(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthUserQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthUser>>>
export type GetAuthUserQueryError = ErrorType<unknown>


export function useGetAuthUser<TData = Awaited<ReturnType<typeof getAuthUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthUser>>,
          TError,
          Awaited<ReturnType<typeof getAuthUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthUser<TData = Awaited<ReturnType<typeof getAuthUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthUser>>,
          TError,
          Awaited<ReturnType<typeof getAuthUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthUser<TData = Awaited<ReturnType<typeof getAuthUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the currently authenticated user
 */

export function useGetAuthUser<TData = Awaited<ReturnType<typeof getAuthUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuthUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Verifies the Turnstile token in production and returns the provider OAuth URL.
 * @summary Start OAuth login after bot verification
 */
export const postAuthLoginProviderStart = (
    provider: 'google' | 'azure',
    postAuthLoginProviderStartBody: BodyType<PostAuthLoginProviderStartBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostAuthLoginProviderStart200>(
      {url: `/auth/login/${provider}/start`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthLoginProviderStartBody, signal
    },
      options);
    }
  


export const getPostAuthLoginProviderStartMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLoginProviderStart>>, TError,{provider: 'google' | 'azure';data: BodyType<PostAuthLoginProviderStartBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthLoginProviderStart>>, TError,{provider: 'google' | 'azure';data: BodyType<PostAuthLoginProviderStartBody>}, TContext> => {

const mutationKey = ['postAuthLoginProviderStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthLoginProviderStart>>, {provider: 'google' | 'azure';data: BodyType<PostAuthLoginProviderStartBody>}> = (props) => {
          const {provider,data} = props ?? {};

          return  postAuthLoginProviderStart(provider,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthLoginProviderStartMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthLoginProviderStart>>>
    export type PostAuthLoginProviderStartMutationBody = BodyType<PostAuthLoginProviderStartBody>
    export type PostAuthLoginProviderStartMutationError = ErrorType<void>

    /**
 * @summary Start OAuth login after bot verification
 */
export const usePostAuthLoginProviderStart = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLoginProviderStart>>, TError,{provider: 'google' | 'azure';data: BodyType<PostAuthLoginProviderStartBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthLoginProviderStart>>,
        TError,
        {provider: 'google' | 'azure';data: BodyType<PostAuthLoginProviderStartBody>},
        TContext
      > => {

      const mutationOptions = getPostAuthLoginProviderStartMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Sends an invitation email and assigns a role within the organization.
 * @summary Invite a new user by email
 */
export const postAuthInvite = (
    postAuthInviteBody: BodyType<PostAuthInviteBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostAuthInvite200>(
      {url: `/auth/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthInviteBody, signal
    },
      options);
    }
  


export const getPostAuthInviteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthInvite>>, TError,{data: BodyType<PostAuthInviteBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthInvite>>, TError,{data: BodyType<PostAuthInviteBody>}, TContext> => {

const mutationKey = ['postAuthInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthInvite>>, {data: BodyType<PostAuthInviteBody>}> = (props) => {
          const {data} = props ?? {};

          return  postAuthInvite(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthInviteMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthInvite>>>
    export type PostAuthInviteMutationBody = BodyType<PostAuthInviteBody>
    export type PostAuthInviteMutationError = ErrorType<void>

    /**
 * @summary Invite a new user by email
 */
export const usePostAuthInvite = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthInvite>>, TError,{data: BodyType<PostAuthInviteBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthInvite>>,
        TError,
        {data: BodyType<PostAuthInviteBody>},
        TContext
      > => {

      const mutationOptions = getPostAuthInviteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Validates that the provided organization ID belongs to the authenticated user, and if valid, stores it as a secure cookie for session context.
 * @summary Set current organization context
 */
export const postAuthSetOrg = (
    postAuthSetOrgBody: BodyType<PostAuthSetOrgBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostAuthSetOrg200>(
      {url: `/auth/set-org`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthSetOrgBody, signal
    },
      options);
    }
  


export const getPostAuthSetOrgMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthSetOrg>>, TError,{data: BodyType<PostAuthSetOrgBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthSetOrg>>, TError,{data: BodyType<PostAuthSetOrgBody>}, TContext> => {

const mutationKey = ['postAuthSetOrg'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthSetOrg>>, {data: BodyType<PostAuthSetOrgBody>}> = (props) => {
          const {data} = props ?? {};

          return  postAuthSetOrg(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthSetOrgMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthSetOrg>>>
    export type PostAuthSetOrgMutationBody = BodyType<PostAuthSetOrgBody>
    export type PostAuthSetOrgMutationError = ErrorType<void>

    /**
 * @summary Set current organization context
 */
export const usePostAuthSetOrg = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthSetOrg>>, TError,{data: BodyType<PostAuthSetOrgBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthSetOrg>>,
        TError,
        {data: BodyType<PostAuthSetOrgBody>},
        TContext
      > => {

      const mutationOptions = getPostAuthSetOrgMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get all buckets for the authenticated user's organization
 */
export const getBuckets = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Bucket[]>(
      {url: `/buckets`, method: 'GET', signal
    },
      options);
    }
  



export const getGetBucketsQueryKey = () => {
    return [
    `/buckets`
    ] as const;
    }

    
export const getGetBucketsQueryOptions = <TData = Awaited<ReturnType<typeof getBuckets>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuckets>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBucketsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuckets>>> = ({ signal }) => getBuckets(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBuckets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBucketsQueryResult = NonNullable<Awaited<ReturnType<typeof getBuckets>>>
export type GetBucketsQueryError = ErrorType<unknown>


export function useGetBuckets<TData = Awaited<ReturnType<typeof getBuckets>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuckets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuckets>>,
          TError,
          Awaited<ReturnType<typeof getBuckets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBuckets<TData = Awaited<ReturnType<typeof getBuckets>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuckets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuckets>>,
          TError,
          Awaited<ReturnType<typeof getBuckets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBuckets<TData = Awaited<ReturnType<typeof getBuckets>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuckets>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all buckets for the authenticated user's organization
 */

export function useGetBuckets<TData = Awaited<ReturnType<typeof getBuckets>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuckets>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBucketsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a new bucket
 */
export const postBuckets = (
    postBucketsBody: BodyType<PostBucketsBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Bucket>(
      {url: `/buckets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postBucketsBody, signal
    },
      options);
    }
  


export const getPostBucketsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBuckets>>, TError,{data: BodyType<PostBucketsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postBuckets>>, TError,{data: BodyType<PostBucketsBody>}, TContext> => {

const mutationKey = ['postBuckets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBuckets>>, {data: BodyType<PostBucketsBody>}> = (props) => {
          const {data} = props ?? {};

          return  postBuckets(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBucketsMutationResult = NonNullable<Awaited<ReturnType<typeof postBuckets>>>
    export type PostBucketsMutationBody = BodyType<PostBucketsBody>
    export type PostBucketsMutationError = ErrorType<unknown>

    /**
 * @summary Create a new bucket
 */
export const usePostBuckets = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBuckets>>, TError,{data: BodyType<PostBucketsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBuckets>>,
        TError,
        {data: BodyType<PostBucketsBody>},
        TContext
      > => {

      const mutationOptions = getPostBucketsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update an existing bucket
 */
export const putBucketsBucketId = (
    bucketId: string,
    putBucketsBucketIdBody: BodyType<PutBucketsBucketIdBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<Bucket>(
      {url: `/buckets/${bucketId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putBucketsBucketIdBody
    },
      options);
    }
  


export const getPutBucketsBucketIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBucketsBucketId>>, TError,{bucketId: string;data: BodyType<PutBucketsBucketIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putBucketsBucketId>>, TError,{bucketId: string;data: BodyType<PutBucketsBucketIdBody>}, TContext> => {

const mutationKey = ['putBucketsBucketId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBucketsBucketId>>, {bucketId: string;data: BodyType<PutBucketsBucketIdBody>}> = (props) => {
          const {bucketId,data} = props ?? {};

          return  putBucketsBucketId(bucketId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBucketsBucketIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBucketsBucketId>>>
    export type PutBucketsBucketIdMutationBody = BodyType<PutBucketsBucketIdBody>
    export type PutBucketsBucketIdMutationError = ErrorType<unknown>

    /**
 * @summary Update an existing bucket
 */
export const usePutBucketsBucketId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBucketsBucketId>>, TError,{bucketId: string;data: BodyType<PutBucketsBucketIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBucketsBucketId>>,
        TError,
        {bucketId: string;data: BodyType<PutBucketsBucketIdBody>},
        TContext
      > => {

      const mutationOptions = getPutBucketsBucketIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete a bucket
 */
export const deleteBucketsBucketId = (
    bucketId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/buckets/${bucketId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteBucketsBucketIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBucketsBucketId>>, TError,{bucketId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBucketsBucketId>>, TError,{bucketId: string}, TContext> => {

const mutationKey = ['deleteBucketsBucketId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBucketsBucketId>>, {bucketId: string}> = (props) => {
          const {bucketId} = props ?? {};

          return  deleteBucketsBucketId(bucketId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBucketsBucketIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBucketsBucketId>>>
    
    export type DeleteBucketsBucketIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete a bucket
 */
export const useDeleteBucketsBucketId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBucketsBucketId>>, TError,{bucketId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBucketsBucketId>>,
        TError,
        {bucketId: string},
        TContext
      > => {

      const mutationOptions = getDeleteBucketsBucketIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get all contacts in a bucket
 */
export const getBucketsBucketIdContacts = (
    bucketId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Contact[]>(
      {url: `/buckets/${bucketId}/contacts`, method: 'GET', signal
    },
      options);
    }
  



export const getGetBucketsBucketIdContactsQueryKey = (bucketId?: string,) => {
    return [
    `/buckets/${bucketId}/contacts`
    ] as const;
    }

    
export const getGetBucketsBucketIdContactsQueryOptions = <TData = Awaited<ReturnType<typeof getBucketsBucketIdContacts>>, TError = ErrorType<unknown>>(bucketId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBucketsBucketIdContacts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBucketsBucketIdContactsQueryKey(bucketId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBucketsBucketIdContacts>>> = ({ signal }) => getBucketsBucketIdContacts(bucketId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(bucketId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBucketsBucketIdContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBucketsBucketIdContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getBucketsBucketIdContacts>>>
export type GetBucketsBucketIdContactsQueryError = ErrorType<unknown>


export function useGetBucketsBucketIdContacts<TData = Awaited<ReturnType<typeof getBucketsBucketIdContacts>>, TError = ErrorType<unknown>>(
 bucketId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBucketsBucketIdContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBucketsBucketIdContacts>>,
          TError,
          Awaited<ReturnType<typeof getBucketsBucketIdContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBucketsBucketIdContacts<TData = Awaited<ReturnType<typeof getBucketsBucketIdContacts>>, TError = ErrorType<unknown>>(
 bucketId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBucketsBucketIdContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBucketsBucketIdContacts>>,
          TError,
          Awaited<ReturnType<typeof getBucketsBucketIdContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBucketsBucketIdContacts<TData = Awaited<ReturnType<typeof getBucketsBucketIdContacts>>, TError = ErrorType<unknown>>(
 bucketId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBucketsBucketIdContacts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all contacts in a bucket
 */

export function useGetBucketsBucketIdContacts<TData = Awaited<ReturnType<typeof getBucketsBucketIdContacts>>, TError = ErrorType<unknown>>(
 bucketId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBucketsBucketIdContacts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBucketsBucketIdContactsQueryOptions(bucketId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Add contacts to a bucket
 */
export const postBucketsContacts = (
    postBucketsContactsBody: BodyType<PostBucketsContactsBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<BucketContact>(
      {url: `/buckets/contacts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postBucketsContactsBody, signal
    },
      options);
    }
  


export const getPostBucketsContactsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBucketsContacts>>, TError,{data: BodyType<PostBucketsContactsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postBucketsContacts>>, TError,{data: BodyType<PostBucketsContactsBody>}, TContext> => {

const mutationKey = ['postBucketsContacts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBucketsContacts>>, {data: BodyType<PostBucketsContactsBody>}> = (props) => {
          const {data} = props ?? {};

          return  postBucketsContacts(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBucketsContactsMutationResult = NonNullable<Awaited<ReturnType<typeof postBucketsContacts>>>
    export type PostBucketsContactsMutationBody = BodyType<PostBucketsContactsBody>
    export type PostBucketsContactsMutationError = ErrorType<unknown>

    /**
 * @summary Add contacts to a bucket
 */
export const usePostBucketsContacts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBucketsContacts>>, TError,{data: BodyType<PostBucketsContactsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBucketsContacts>>,
        TError,
        {data: BodyType<PostBucketsContactsBody>},
        TContext
      > => {

      const mutationOptions = getPostBucketsContactsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Remove a contact from a bucket
 */
export const deleteBucketsBucketIdContactsContactId = (
    bucketId: string,
    contactId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/buckets/${bucketId}/contacts/${contactId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteBucketsBucketIdContactsContactIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBucketsBucketIdContactsContactId>>, TError,{bucketId: string;contactId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBucketsBucketIdContactsContactId>>, TError,{bucketId: string;contactId: string}, TContext> => {

const mutationKey = ['deleteBucketsBucketIdContactsContactId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBucketsBucketIdContactsContactId>>, {bucketId: string;contactId: string}> = (props) => {
          const {bucketId,contactId} = props ?? {};

          return  deleteBucketsBucketIdContactsContactId(bucketId,contactId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBucketsBucketIdContactsContactIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBucketsBucketIdContactsContactId>>>
    
    export type DeleteBucketsBucketIdContactsContactIdMutationError = ErrorType<unknown>

    /**
 * @summary Remove a contact from a bucket
 */
export const useDeleteBucketsBucketIdContactsContactId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBucketsBucketIdContactsContactId>>, TError,{bucketId: string;contactId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBucketsBucketIdContactsContactId>>,
        TError,
        {bucketId: string;contactId: string},
        TContext
      > => {

      const mutationOptions = getDeleteBucketsBucketIdContactsContactIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Takes a LinkedIn profile URL and enriches it into a structured candidate object, including parsed profile data, work experiences, education, and related information.

 * @summary Create a candidate from a LinkedIn profile
 */
export const postCandidates = (
    postCandidatesBody: BodyType<PostCandidatesBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostCandidates200>(
      {url: `/candidates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCandidatesBody, signal
    },
      options);
    }
  


export const getPostCandidatesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCandidates>>, TError,{data: BodyType<PostCandidatesBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postCandidates>>, TError,{data: BodyType<PostCandidatesBody>}, TContext> => {

const mutationKey = ['postCandidates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidates>>, {data: BodyType<PostCandidatesBody>}> = (props) => {
          const {data} = props ?? {};

          return  postCandidates(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCandidatesMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidates>>>
    export type PostCandidatesMutationBody = BodyType<PostCandidatesBody>
    export type PostCandidatesMutationError = ErrorType<void>

    /**
 * @summary Create a candidate from a LinkedIn profile
 */
export const usePostCandidates = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCandidates>>, TError,{data: BodyType<PostCandidatesBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCandidates>>,
        TError,
        {data: BodyType<PostCandidatesBody>},
        TContext
      > => {

      const mutationOptions = getPostCandidatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List candidates for the organization
 */
export const getCandidates = (
    params?: GetCandidatesParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetCandidates200>(
      {url: `/candidates`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCandidatesQueryKey = (params?: GetCandidatesParams,) => {
    return [
    `/candidates`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof getCandidates>>, TError = ErrorType<void>>(params?: GetCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidates>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidates>>> = ({ signal }) => getCandidates(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidates>>>
export type GetCandidatesQueryError = ErrorType<void>


export function useGetCandidates<TData = Awaited<ReturnType<typeof getCandidates>>, TError = ErrorType<void>>(
 params: undefined |  GetCandidatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidates>>,
          TError,
          Awaited<ReturnType<typeof getCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidates<TData = Awaited<ReturnType<typeof getCandidates>>, TError = ErrorType<void>>(
 params?: GetCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidates>>,
          TError,
          Awaited<ReturnType<typeof getCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidates<TData = Awaited<ReturnType<typeof getCandidates>>, TError = ErrorType<void>>(
 params?: GetCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidates>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List candidates for the organization
 */

export function useGetCandidates<TData = Awaited<ReturnType<typeof getCandidates>>, TError = ErrorType<void>>(
 params?: GetCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidates>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Upload a resume file (PDF or DOCX).   The API extracts candidate details such as full name, headline, skills, experiences, and contact information, then creates a new candidate record in the database along with parsed raw JSON.

 * @summary Upload and parse a resume to create a candidate record
 */
export const postCandidatesResume = (
    structuredResumeCandidate: BodyType<StructuredResumeCandidate>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostCandidatesResume200>(
      {url: `/candidates/resume`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: structuredResumeCandidate, signal
    },
      options);
    }
  


export const getPostCandidatesResumeMutationOptions = <TError = ErrorType<void | CandidateDuplicateErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCandidatesResume>>, TError,{data: BodyType<StructuredResumeCandidate>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesResume>>, TError,{data: BodyType<StructuredResumeCandidate>}, TContext> => {

const mutationKey = ['postCandidatesResume'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesResume>>, {data: BodyType<StructuredResumeCandidate>}> = (props) => {
          const {data} = props ?? {};

          return  postCandidatesResume(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCandidatesResumeMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidatesResume>>>
    export type PostCandidatesResumeMutationBody = BodyType<StructuredResumeCandidate>
    export type PostCandidatesResumeMutationError = ErrorType<void | CandidateDuplicateErrorResponse>

    /**
 * @summary Upload and parse a resume to create a candidate record
 */
export const usePostCandidatesResume = <TError = ErrorType<void | CandidateDuplicateErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCandidatesResume>>, TError,{data: BodyType<StructuredResumeCandidate>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCandidatesResume>>,
        TError,
        {data: BodyType<StructuredResumeCandidate>},
        TContext
      > => {

      const mutationOptions = getPostCandidatesResumeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the organization-aware candidate profile (base profile + org overrides), including merged experiences.

 * @summary Get merged candidate profile for organization
 */
export const getCandidatesCandidateId = (
    candidateId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<CandidateProfile>(
      {url: `/candidates/${candidateId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCandidatesCandidateIdQueryKey = (candidateId?: string,) => {
    return [
    `/candidates/${candidateId}`
    ] as const;
    }

    
export const getGetCandidatesCandidateIdQueryOptions = <TData = Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError = ErrorType<void>>(candidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidatesCandidateIdQueryKey(candidateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesCandidateId>>> = ({ signal }) => getCandidatesCandidateId(candidateId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(candidateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCandidatesCandidateIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesCandidateId>>>
export type GetCandidatesCandidateIdQueryError = ErrorType<void>


export function useGetCandidatesCandidateId<TData = Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError = ErrorType<void>>(
 candidateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidatesCandidateId>>,
          TError,
          Awaited<ReturnType<typeof getCandidatesCandidateId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidatesCandidateId<TData = Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError = ErrorType<void>>(
 candidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidatesCandidateId>>,
          TError,
          Awaited<ReturnType<typeof getCandidatesCandidateId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidatesCandidateId<TData = Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError = ErrorType<void>>(
 candidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get merged candidate profile for organization
 */

export function useGetCandidatesCandidateId<TData = Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError = ErrorType<void>>(
 candidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCandidatesCandidateIdQueryOptions(candidateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Applies patch updates to organization-specific candidate fields and returns the merged profile.

 * @summary Update organization-level candidate overrides
 */
export const patchCandidatesCandidateId = (
    candidateId: string,
    patchCandidatesCandidateIdBody: BodyType<PatchCandidatesCandidateIdBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<CandidateProfile>(
      {url: `/candidates/${candidateId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchCandidatesCandidateIdBody
    },
      options);
    }
  


export const getPatchCandidatesCandidateIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCandidatesCandidateId>>, TError,{candidateId: string;data: BodyType<PatchCandidatesCandidateIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCandidatesCandidateId>>, TError,{candidateId: string;data: BodyType<PatchCandidatesCandidateIdBody>}, TContext> => {

const mutationKey = ['patchCandidatesCandidateId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCandidatesCandidateId>>, {candidateId: string;data: BodyType<PatchCandidatesCandidateIdBody>}> = (props) => {
          const {candidateId,data} = props ?? {};

          return  patchCandidatesCandidateId(candidateId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCandidatesCandidateIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCandidatesCandidateId>>>
    export type PatchCandidatesCandidateIdMutationBody = BodyType<PatchCandidatesCandidateIdBody>
    export type PatchCandidatesCandidateIdMutationError = ErrorType<void>

    /**
 * @summary Update organization-level candidate overrides
 */
export const usePatchCandidatesCandidateId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCandidatesCandidateId>>, TError,{candidateId: string;data: BodyType<PatchCandidatesCandidateIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCandidatesCandidateId>>,
        TError,
        {candidateId: string;data: BodyType<PatchCandidatesCandidateIdBody>},
        TContext
      > => {

      const mutationOptions = getPatchCandidatesCandidateIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Removes organization candidate override and organization experience overrides for this candidate.

 * @summary Delete organization-level candidate overrides
 */
export const deleteCandidatesCandidateId = (
    candidateId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/candidates/${candidateId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCandidatesCandidateIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCandidatesCandidateId>>, TError,{candidateId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCandidatesCandidateId>>, TError,{candidateId: string}, TContext> => {

const mutationKey = ['deleteCandidatesCandidateId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCandidatesCandidateId>>, {candidateId: string}> = (props) => {
          const {candidateId} = props ?? {};

          return  deleteCandidatesCandidateId(candidateId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCandidatesCandidateIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCandidatesCandidateId>>>
    
    export type DeleteCandidatesCandidateIdMutationError = ErrorType<void>

    /**
 * @summary Delete organization-level candidate overrides
 */
export const useDeleteCandidatesCandidateId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCandidatesCandidateId>>, TError,{candidateId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCandidatesCandidateId>>,
        TError,
        {candidateId: string},
        TContext
      > => {

      const mutationOptions = getDeleteCandidatesCandidateIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Applies patch updates for one base candidate experience override and returns the merged candidate profile.

 * @summary Update organization-level experience override
 */
export const patchCandidatesCandidateIdExperiences = (
    candidateId: string,
    patchCandidatesCandidateIdExperiencesBody: BodyType<PatchCandidatesCandidateIdExperiencesBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<CandidateProfile>(
      {url: `/candidates/${candidateId}/experiences`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchCandidatesCandidateIdExperiencesBody
    },
      options);
    }
  


export const getPatchCandidatesCandidateIdExperiencesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCandidatesCandidateIdExperiences>>, TError,{candidateId: string;data: BodyType<PatchCandidatesCandidateIdExperiencesBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCandidatesCandidateIdExperiences>>, TError,{candidateId: string;data: BodyType<PatchCandidatesCandidateIdExperiencesBody>}, TContext> => {

const mutationKey = ['patchCandidatesCandidateIdExperiences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCandidatesCandidateIdExperiences>>, {candidateId: string;data: BodyType<PatchCandidatesCandidateIdExperiencesBody>}> = (props) => {
          const {candidateId,data} = props ?? {};

          return  patchCandidatesCandidateIdExperiences(candidateId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCandidatesCandidateIdExperiencesMutationResult = NonNullable<Awaited<ReturnType<typeof patchCandidatesCandidateIdExperiences>>>
    export type PatchCandidatesCandidateIdExperiencesMutationBody = BodyType<PatchCandidatesCandidateIdExperiencesBody>
    export type PatchCandidatesCandidateIdExperiencesMutationError = ErrorType<void>

    /**
 * @summary Update organization-level experience override
 */
export const usePatchCandidatesCandidateIdExperiences = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCandidatesCandidateIdExperiences>>, TError,{candidateId: string;data: BodyType<PatchCandidatesCandidateIdExperiencesBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCandidatesCandidateIdExperiences>>,
        TError,
        {candidateId: string;data: BodyType<PatchCandidatesCandidateIdExperiencesBody>},
        TContext
      > => {

      const mutationOptions = getPatchCandidatesCandidateIdExperiencesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Deletes the organization override row for a base candidate experience.

 * @summary Delete organization-level experience override
 */
export const deleteCandidatesCandidateIdExperiencesExperienceId = (
    candidateId: string,
    experienceId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/candidates/${candidateId}/experiences/${experienceId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCandidatesCandidateIdExperiencesExperienceIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCandidatesCandidateIdExperiencesExperienceId>>, TError,{candidateId: string;experienceId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCandidatesCandidateIdExperiencesExperienceId>>, TError,{candidateId: string;experienceId: string}, TContext> => {

const mutationKey = ['deleteCandidatesCandidateIdExperiencesExperienceId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCandidatesCandidateIdExperiencesExperienceId>>, {candidateId: string;experienceId: string}> = (props) => {
          const {candidateId,experienceId} = props ?? {};

          return  deleteCandidatesCandidateIdExperiencesExperienceId(candidateId,experienceId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCandidatesCandidateIdExperiencesExperienceIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCandidatesCandidateIdExperiencesExperienceId>>>
    
    export type DeleteCandidatesCandidateIdExperiencesExperienceIdMutationError = ErrorType<void>

    /**
 * @summary Delete organization-level experience override
 */
export const useDeleteCandidatesCandidateIdExperiencesExperienceId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCandidatesCandidateIdExperiencesExperienceId>>, TError,{candidateId: string;experienceId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCandidatesCandidateIdExperiencesExperienceId>>,
        TError,
        {candidateId: string;experienceId: string},
        TContext
      > => {

      const mutationOptions = getDeleteCandidatesCandidateIdExperiencesExperienceIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List of candidate's jobs in an organization
 */
export const getCandidatesCandidateIdJobs = (
    candidateId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetCandidatesCandidateIdJobs200Item[]>(
      {url: `/candidates/${candidateId}/jobs`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCandidatesCandidateIdJobsQueryKey = (candidateId?: string,) => {
    return [
    `/candidates/${candidateId}/jobs`
    ] as const;
    }

    
export const getGetCandidatesCandidateIdJobsQueryOptions = <TData = Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>, TError = ErrorType<unknown>>(candidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidatesCandidateIdJobsQueryKey(candidateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>> = ({ signal }) => getCandidatesCandidateIdJobs(candidateId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(candidateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCandidatesCandidateIdJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>>
export type GetCandidatesCandidateIdJobsQueryError = ErrorType<unknown>


export function useGetCandidatesCandidateIdJobs<TData = Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>, TError = ErrorType<unknown>>(
 candidateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>,
          TError,
          Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidatesCandidateIdJobs<TData = Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>, TError = ErrorType<unknown>>(
 candidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>,
          TError,
          Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidatesCandidateIdJobs<TData = Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>, TError = ErrorType<unknown>>(
 candidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of candidate's jobs in an organization
 */

export function useGetCandidatesCandidateIdJobs<TData = Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>, TError = ErrorType<unknown>>(
 candidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdJobs>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCandidatesCandidateIdJobsQueryOptions(candidateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns a unified, chronological history feed for a candidate. The timeline aggregates outreach, comments, tasks, stage transitions, and calendar events into a single, UI-friendly shape. By default, history spans all jobs for the candidate. Optionally scope to a specific job.

 * @summary Get unified candidate history timeline
 */
export const getCandidatesCandidateIdTimeline = (
    candidateId: string,
    params?: GetCandidatesCandidateIdTimelineParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<CandidateTimelineItemV1[]>(
      {url: `/candidates/${candidateId}/timeline`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCandidatesCandidateIdTimelineQueryKey = (candidateId?: string,
    params?: GetCandidatesCandidateIdTimelineParams,) => {
    return [
    `/candidates/${candidateId}/timeline`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCandidatesCandidateIdTimelineQueryOptions = <TData = Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>, TError = ErrorType<void>>(candidateId: string,
    params?: GetCandidatesCandidateIdTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidatesCandidateIdTimelineQueryKey(candidateId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>> = ({ signal }) => getCandidatesCandidateIdTimeline(candidateId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(candidateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCandidatesCandidateIdTimelineQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>>
export type GetCandidatesCandidateIdTimelineQueryError = ErrorType<void>


export function useGetCandidatesCandidateIdTimeline<TData = Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>, TError = ErrorType<void>>(
 candidateId: string,
    params: undefined |  GetCandidatesCandidateIdTimelineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>,
          TError,
          Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidatesCandidateIdTimeline<TData = Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>, TError = ErrorType<void>>(
 candidateId: string,
    params?: GetCandidatesCandidateIdTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>,
          TError,
          Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidatesCandidateIdTimeline<TData = Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>, TError = ErrorType<void>>(
 candidateId: string,
    params?: GetCandidatesCandidateIdTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get unified candidate history timeline
 */

export function useGetCandidatesCandidateIdTimeline<TData = Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>, TError = ErrorType<void>>(
 candidateId: string,
    params?: GetCandidatesCandidateIdTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdTimeline>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCandidatesCandidateIdTimelineQueryOptions(candidateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Fetches all jobs assigned to an array of candidate IDs.  
Each result includes job details, stage information, and the company name.

 * @summary Retrieve jobs associated with multiple candidates
 */
export const postCandidatesCandidateJobs = (
    postCandidatesCandidateJobsBody: BodyType<PostCandidatesCandidateJobsBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostCandidatesCandidateJobs200Item[]>(
      {url: `/candidates/candidate-jobs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCandidatesCandidateJobsBody, signal
    },
      options);
    }
  


export const getPostCandidatesCandidateJobsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateJobs>>, TError,{data: BodyType<PostCandidatesCandidateJobsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateJobs>>, TError,{data: BodyType<PostCandidatesCandidateJobsBody>}, TContext> => {

const mutationKey = ['postCandidatesCandidateJobs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesCandidateJobs>>, {data: BodyType<PostCandidatesCandidateJobsBody>}> = (props) => {
          const {data} = props ?? {};

          return  postCandidatesCandidateJobs(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCandidatesCandidateJobsMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidatesCandidateJobs>>>
    export type PostCandidatesCandidateJobsMutationBody = BodyType<PostCandidatesCandidateJobsBody>
    export type PostCandidatesCandidateJobsMutationError = ErrorType<void>

    /**
 * @summary Retrieve jobs associated with multiple candidates
 */
export const usePostCandidatesCandidateJobs = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateJobs>>, TError,{data: BodyType<PostCandidatesCandidateJobsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCandidatesCandidateJobs>>,
        TError,
        {data: BodyType<PostCandidatesCandidateJobsBody>},
        TContext
      > => {

      const mutationOptions = getPostCandidatesCandidateJobsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns a list of candidate-job associations for the authenticated user's organization.
You can filter results by candidate name or job ID.
Each record represents a candidate linked to a specific job, including the candidate's
basic profile, job information, and the associated company.

 * @summary Search candidates within an organization
 */
export const getCandidatesSearch = (
    params?: GetCandidatesSearchParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetCandidatesSearch200Item[]>(
      {url: `/candidates/search`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCandidatesSearchQueryKey = (params?: GetCandidatesSearchParams,) => {
    return [
    `/candidates/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCandidatesSearchQueryOptions = <TData = Awaited<ReturnType<typeof getCandidatesSearch>>, TError = ErrorType<void>>(params?: GetCandidatesSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidatesSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesSearch>>> = ({ signal }) => getCandidatesSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidatesSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCandidatesSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesSearch>>>
export type GetCandidatesSearchQueryError = ErrorType<void>


export function useGetCandidatesSearch<TData = Awaited<ReturnType<typeof getCandidatesSearch>>, TError = ErrorType<void>>(
 params: undefined |  GetCandidatesSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidatesSearch>>,
          TError,
          Awaited<ReturnType<typeof getCandidatesSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidatesSearch<TData = Awaited<ReturnType<typeof getCandidatesSearch>>, TError = ErrorType<void>>(
 params?: GetCandidatesSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidatesSearch>>,
          TError,
          Awaited<ReturnType<typeof getCandidatesSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidatesSearch<TData = Awaited<ReturnType<typeof getCandidatesSearch>>, TError = ErrorType<void>>(
 params?: GetCandidatesSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search candidates within an organization
 */

export function useGetCandidatesSearch<TData = Awaited<ReturnType<typeof getCandidatesSearch>>, TError = ErrorType<void>>(
 params?: GetCandidatesSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidatesSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCandidatesSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Upload a resume file (PDF or DOCX).   The API extracts candidate details such as full name, headline, skills, experiences, and contact information, then creates a new candidate record in the database along with parsed raw JSON.

 * @summary Upload and parse a resume to create a candidate record
 */
export const postCandidatesParseResume = (
    postCandidatesParseResumeBody: BodyType<PostCandidatesParseResumeBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`resume`, postCandidatesParseResumeBody.resume)

      return customClient<StructuredResumeCandidate>(
      {url: `/candidates/parse-resume`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getPostCandidatesParseResumeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCandidatesParseResume>>, TError,{data: BodyType<PostCandidatesParseResumeBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesParseResume>>, TError,{data: BodyType<PostCandidatesParseResumeBody>}, TContext> => {

const mutationKey = ['postCandidatesParseResume'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesParseResume>>, {data: BodyType<PostCandidatesParseResumeBody>}> = (props) => {
          const {data} = props ?? {};

          return  postCandidatesParseResume(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCandidatesParseResumeMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidatesParseResume>>>
    export type PostCandidatesParseResumeMutationBody = BodyType<PostCandidatesParseResumeBody>
    export type PostCandidatesParseResumeMutationError = ErrorType<void>

    /**
 * @summary Upload and parse a resume to create a candidate record
 */
export const usePostCandidatesParseResume = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCandidatesParseResume>>, TError,{data: BodyType<PostCandidatesParseResumeBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCandidatesParseResume>>,
        TError,
        {data: BodyType<PostCandidatesParseResumeBody>},
        TContext
      > => {

      const mutationOptions = getPostCandidatesParseResumeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List comments for an entity
 */
export const getComments = (
    params: GetCommentsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Comment[]>(
      {url: `/comments`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCommentsQueryKey = (params?: GetCommentsParams,) => {
    return [
    `/comments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getComments>>, TError = ErrorType<unknown>>(params: GetCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getComments>>> = ({ signal }) => getComments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getComments>>>
export type GetCommentsQueryError = ErrorType<unknown>


export function useGetComments<TData = Awaited<ReturnType<typeof getComments>>, TError = ErrorType<unknown>>(
 params: GetCommentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getComments>>,
          TError,
          Awaited<ReturnType<typeof getComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetComments<TData = Awaited<ReturnType<typeof getComments>>, TError = ErrorType<unknown>>(
 params: GetCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getComments>>,
          TError,
          Awaited<ReturnType<typeof getComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetComments<TData = Awaited<ReturnType<typeof getComments>>, TError = ErrorType<unknown>>(
 params: GetCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List comments for an entity
 */

export function useGetComments<TData = Awaited<ReturnType<typeof getComments>>, TError = ErrorType<unknown>>(
 params: GetCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a comment
 */
export const postComments = (
    postCommentsBody: BodyType<PostCommentsBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Comment>(
      {url: `/comments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCommentsBody, signal
    },
      options);
    }
  


export const getPostCommentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postComments>>, TError,{data: BodyType<PostCommentsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postComments>>, TError,{data: BodyType<PostCommentsBody>}, TContext> => {

const mutationKey = ['postComments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postComments>>, {data: BodyType<PostCommentsBody>}> = (props) => {
          const {data} = props ?? {};

          return  postComments(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommentsMutationResult = NonNullable<Awaited<ReturnType<typeof postComments>>>
    export type PostCommentsMutationBody = BodyType<PostCommentsBody>
    export type PostCommentsMutationError = ErrorType<unknown>

    /**
 * @summary Create a comment
 */
export const usePostComments = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postComments>>, TError,{data: BodyType<PostCommentsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postComments>>,
        TError,
        {data: BodyType<PostCommentsBody>},
        TContext
      > => {

      const mutationOptions = getPostCommentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update a comment
 */
export const putCommentsCommentId = (
    commentId: string,
    putCommentsCommentIdBody: BodyType<PutCommentsCommentIdBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<Comment>(
      {url: `/comments/${commentId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putCommentsCommentIdBody
    },
      options);
    }
  


export const getPutCommentsCommentIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCommentsCommentId>>, TError,{commentId: string;data: BodyType<PutCommentsCommentIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putCommentsCommentId>>, TError,{commentId: string;data: BodyType<PutCommentsCommentIdBody>}, TContext> => {

const mutationKey = ['putCommentsCommentId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCommentsCommentId>>, {commentId: string;data: BodyType<PutCommentsCommentIdBody>}> = (props) => {
          const {commentId,data} = props ?? {};

          return  putCommentsCommentId(commentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCommentsCommentIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCommentsCommentId>>>
    export type PutCommentsCommentIdMutationBody = BodyType<PutCommentsCommentIdBody>
    export type PutCommentsCommentIdMutationError = ErrorType<unknown>

    /**
 * @summary Update a comment
 */
export const usePutCommentsCommentId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCommentsCommentId>>, TError,{commentId: string;data: BodyType<PutCommentsCommentIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCommentsCommentId>>,
        TError,
        {commentId: string;data: BodyType<PutCommentsCommentIdBody>},
        TContext
      > => {

      const mutationOptions = getPutCommentsCommentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete a comment
 */
export const deleteCommentsCommentId = (
    commentId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/comments/${commentId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCommentsCommentIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommentsCommentId>>, TError,{commentId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCommentsCommentId>>, TError,{commentId: string}, TContext> => {

const mutationKey = ['deleteCommentsCommentId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCommentsCommentId>>, {commentId: string}> = (props) => {
          const {commentId} = props ?? {};

          return  deleteCommentsCommentId(commentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCommentsCommentIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCommentsCommentId>>>
    
    export type DeleteCommentsCommentIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete a comment
 */
export const useDeleteCommentsCommentId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommentsCommentId>>, TError,{commentId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCommentsCommentId>>,
        TError,
        {commentId: string},
        TContext
      > => {

      const mutationOptions = getDeleteCommentsCommentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List companies (connected to the organization)
 */
export const getCompanies = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetCompanies200>(
      {url: `/companies`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCompaniesQueryKey = () => {
    return [
    `/companies`
    ] as const;
    }

    
export const getGetCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompaniesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanies>>> = ({ signal }) => getCompanies(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanies>>>
export type GetCompaniesQueryError = ErrorType<unknown>


export function useGetCompanies<TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanies>>,
          TError,
          Awaited<ReturnType<typeof getCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanies<TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanies>>,
          TError,
          Awaited<ReturnType<typeof getCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanies<TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List companies (connected to the organization)
 */

export function useGetCompanies<TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompaniesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a company
 */
export const postCompanies = (
    postCompaniesBody: BodyType<PostCompaniesBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Company>(
      {url: `/companies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCompaniesBody, signal
    },
      options);
    }
  


export const getPostCompaniesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanies>>, TError,{data: BodyType<PostCompaniesBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanies>>, TError,{data: BodyType<PostCompaniesBody>}, TContext> => {

const mutationKey = ['postCompanies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanies>>, {data: BodyType<PostCompaniesBody>}> = (props) => {
          const {data} = props ?? {};

          return  postCompanies(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanies>>>
    export type PostCompaniesMutationBody = BodyType<PostCompaniesBody>
    export type PostCompaniesMutationError = ErrorType<unknown>

    /**
 * @summary Create a company
 */
export const usePostCompanies = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanies>>, TError,{data: BodyType<PostCompaniesBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCompanies>>,
        TError,
        {data: BodyType<PostCompaniesBody>},
        TContext
      > => {

      const mutationOptions = getPostCompaniesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the total number of jobs and contacts associated with each company.
 * @summary Get the count of jobs and contacts for multiple companies
 */
export const getCompaniesJobContactCounts = (
    params: GetCompaniesJobContactCountsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetCompaniesJobContactCounts200>(
      {url: `/companies/jobContactCounts`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCompaniesJobContactCountsQueryKey = (params?: GetCompaniesJobContactCountsParams,) => {
    return [
    `/companies/jobContactCounts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCompaniesJobContactCountsQueryOptions = <TData = Awaited<ReturnType<typeof getCompaniesJobContactCounts>>, TError = ErrorType<void>>(params: GetCompaniesJobContactCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompaniesJobContactCounts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompaniesJobContactCountsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompaniesJobContactCounts>>> = ({ signal }) => getCompaniesJobContactCounts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompaniesJobContactCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompaniesJobContactCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompaniesJobContactCounts>>>
export type GetCompaniesJobContactCountsQueryError = ErrorType<void>


export function useGetCompaniesJobContactCounts<TData = Awaited<ReturnType<typeof getCompaniesJobContactCounts>>, TError = ErrorType<void>>(
 params: GetCompaniesJobContactCountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompaniesJobContactCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompaniesJobContactCounts>>,
          TError,
          Awaited<ReturnType<typeof getCompaniesJobContactCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompaniesJobContactCounts<TData = Awaited<ReturnType<typeof getCompaniesJobContactCounts>>, TError = ErrorType<void>>(
 params: GetCompaniesJobContactCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompaniesJobContactCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompaniesJobContactCounts>>,
          TError,
          Awaited<ReturnType<typeof getCompaniesJobContactCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompaniesJobContactCounts<TData = Awaited<ReturnType<typeof getCompaniesJobContactCounts>>, TError = ErrorType<void>>(
 params: GetCompaniesJobContactCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompaniesJobContactCounts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the count of jobs and contacts for multiple companies
 */

export function useGetCompaniesJobContactCounts<TData = Awaited<ReturnType<typeof getCompaniesJobContactCounts>>, TError = ErrorType<void>>(
 params: GetCompaniesJobContactCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompaniesJobContactCounts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompaniesJobContactCountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get company by ID
 */
export const getCompaniesCompanyId = (
    companyId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Company>(
      {url: `/companies/${companyId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCompaniesCompanyIdQueryKey = (companyId?: string,) => {
    return [
    `/companies/${companyId}`
    ] as const;
    }

    
export const getGetCompaniesCompanyIdQueryOptions = <TData = Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError = ErrorType<unknown>>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompaniesCompanyIdQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompaniesCompanyId>>> = ({ signal }) => getCompaniesCompanyId(companyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompaniesCompanyIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCompaniesCompanyId>>>
export type GetCompaniesCompanyIdQueryError = ErrorType<unknown>


export function useGetCompaniesCompanyId<TData = Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError = ErrorType<unknown>>(
 companyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompaniesCompanyId>>,
          TError,
          Awaited<ReturnType<typeof getCompaniesCompanyId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompaniesCompanyId<TData = Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompaniesCompanyId>>,
          TError,
          Awaited<ReturnType<typeof getCompaniesCompanyId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompaniesCompanyId<TData = Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get company by ID
 */

export function useGetCompaniesCompanyId<TData = Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompaniesCompanyIdQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update a company
 */
export const putCompaniesCompanyId = (
    companyId: string,
    putCompaniesCompanyIdBody: BodyType<PutCompaniesCompanyIdBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<Company>(
      {url: `/companies/${companyId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putCompaniesCompanyIdBody
    },
      options);
    }
  


export const getPutCompaniesCompanyIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompaniesCompanyId>>, TError,{companyId: string;data: BodyType<PutCompaniesCompanyIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putCompaniesCompanyId>>, TError,{companyId: string;data: BodyType<PutCompaniesCompanyIdBody>}, TContext> => {

const mutationKey = ['putCompaniesCompanyId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompaniesCompanyId>>, {companyId: string;data: BodyType<PutCompaniesCompanyIdBody>}> = (props) => {
          const {companyId,data} = props ?? {};

          return  putCompaniesCompanyId(companyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCompaniesCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCompaniesCompanyId>>>
    export type PutCompaniesCompanyIdMutationBody = BodyType<PutCompaniesCompanyIdBody>
    export type PutCompaniesCompanyIdMutationError = ErrorType<unknown>

    /**
 * @summary Update a company
 */
export const usePutCompaniesCompanyId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompaniesCompanyId>>, TError,{companyId: string;data: BodyType<PutCompaniesCompanyIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCompaniesCompanyId>>,
        TError,
        {companyId: string;data: BodyType<PutCompaniesCompanyIdBody>},
        TContext
      > => {

      const mutationOptions = getPutCompaniesCompanyIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete a company
 */
export const deleteCompaniesCompanyId = (
    companyId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/companies/${companyId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCompaniesCompanyIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompaniesCompanyId>>, TError,{companyId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompaniesCompanyId>>, TError,{companyId: string}, TContext> => {

const mutationKey = ['deleteCompaniesCompanyId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompaniesCompanyId>>, {companyId: string}> = (props) => {
          const {companyId} = props ?? {};

          return  deleteCompaniesCompanyId(companyId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompaniesCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompaniesCompanyId>>>
    
    export type DeleteCompaniesCompanyIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete a company
 */
export const useDeleteCompaniesCompanyId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompaniesCompanyId>>, TError,{companyId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompaniesCompanyId>>,
        TError,
        {companyId: string},
        TContext
      > => {

      const mutationOptions = getDeleteCompaniesCompanyIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List contacts (connected to a job, a company or the organization)
 */
export const getContacts = (
    params?: GetContactsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Contact[]>(
      {url: `/contacts`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetContactsQueryKey = (params?: GetContactsParams,) => {
    return [
    `/contacts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetContactsQueryOptions = <TData = Awaited<ReturnType<typeof getContacts>>, TError = ErrorType<unknown>>(params?: GetContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContactsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContacts>>> = ({ signal }) => getContacts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getContacts>>>
export type GetContactsQueryError = ErrorType<unknown>


export function useGetContacts<TData = Awaited<ReturnType<typeof getContacts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetContactsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContacts>>,
          TError,
          Awaited<ReturnType<typeof getContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContacts<TData = Awaited<ReturnType<typeof getContacts>>, TError = ErrorType<unknown>>(
 params?: GetContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContacts>>,
          TError,
          Awaited<ReturnType<typeof getContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContacts<TData = Awaited<ReturnType<typeof getContacts>>, TError = ErrorType<unknown>>(
 params?: GetContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List contacts (connected to a job, a company or the organization)
 */

export function useGetContacts<TData = Awaited<ReturnType<typeof getContacts>>, TError = ErrorType<unknown>>(
 params?: GetContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContactsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a contact
 */
export const postContacts = (
    postContactsBody: BodyType<PostContactsBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Contact>(
      {url: `/contacts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postContactsBody, signal
    },
      options);
    }
  


export const getPostContactsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContacts>>, TError,{data: BodyType<PostContactsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postContacts>>, TError,{data: BodyType<PostContactsBody>}, TContext> => {

const mutationKey = ['postContacts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContacts>>, {data: BodyType<PostContactsBody>}> = (props) => {
          const {data} = props ?? {};

          return  postContacts(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostContactsMutationResult = NonNullable<Awaited<ReturnType<typeof postContacts>>>
    export type PostContactsMutationBody = BodyType<PostContactsBody>
    export type PostContactsMutationError = ErrorType<unknown>

    /**
 * @summary Create a contact
 */
export const usePostContacts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContacts>>, TError,{data: BodyType<PostContactsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postContacts>>,
        TError,
        {data: BodyType<PostContactsBody>},
        TContext
      > => {

      const mutationOptions = getPostContactsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Link a contact as a job hiring manager
 */
export const postContactsHiringManagers = (
    postContactsHiringManagersBody: BodyType<PostContactsHiringManagersBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostContactsHiringManagers201>(
      {url: `/contacts/hiring-managers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postContactsHiringManagersBody, signal
    },
      options);
    }
  


export const getPostContactsHiringManagersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContactsHiringManagers>>, TError,{data: BodyType<PostContactsHiringManagersBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postContactsHiringManagers>>, TError,{data: BodyType<PostContactsHiringManagersBody>}, TContext> => {

const mutationKey = ['postContactsHiringManagers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsHiringManagers>>, {data: BodyType<PostContactsHiringManagersBody>}> = (props) => {
          const {data} = props ?? {};

          return  postContactsHiringManagers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostContactsHiringManagersMutationResult = NonNullable<Awaited<ReturnType<typeof postContactsHiringManagers>>>
    export type PostContactsHiringManagersMutationBody = BodyType<PostContactsHiringManagersBody>
    export type PostContactsHiringManagersMutationError = ErrorType<unknown>

    /**
 * @summary Link a contact as a job hiring manager
 */
export const usePostContactsHiringManagers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContactsHiringManagers>>, TError,{data: BodyType<PostContactsHiringManagersBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postContactsHiringManagers>>,
        TError,
        {data: BodyType<PostContactsHiringManagersBody>},
        TContext
      > => {

      const mutationOptions = getPostContactsHiringManagersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Deletes a job → contact link in the `job_hiring_managers` table.
 * @summary Remove a hiring manager from a job
 */
export const deleteContactsHiringManagers = (
    deleteContactsHiringManagersBody: BodyType<DeleteContactsHiringManagersBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<DeleteContactsHiringManagers200Item[]>(
      {url: `/contacts/hiring-managers`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteContactsHiringManagersBody
    },
      options);
    }
  


export const getDeleteContactsHiringManagersMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactsHiringManagers>>, TError,{data: BodyType<DeleteContactsHiringManagersBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteContactsHiringManagers>>, TError,{data: BodyType<DeleteContactsHiringManagersBody>}, TContext> => {

const mutationKey = ['deleteContactsHiringManagers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContactsHiringManagers>>, {data: BodyType<DeleteContactsHiringManagersBody>}> = (props) => {
          const {data} = props ?? {};

          return  deleteContactsHiringManagers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteContactsHiringManagersMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContactsHiringManagers>>>
    export type DeleteContactsHiringManagersMutationBody = BodyType<DeleteContactsHiringManagersBody>
    export type DeleteContactsHiringManagersMutationError = ErrorType<void>

    /**
 * @summary Remove a hiring manager from a job
 */
export const useDeleteContactsHiringManagers = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactsHiringManagers>>, TError,{data: BodyType<DeleteContactsHiringManagersBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteContactsHiringManagers>>,
        TError,
        {data: BodyType<DeleteContactsHiringManagersBody>},
        TContext
      > => {

      const mutationOptions = getDeleteContactsHiringManagersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates a new contact or, if a contact already exists for the same candidate_id and the authenticated user (created_by),
updates that contact instead. If candidate_id is not provided, the endpoint will always create a new contact.

 * @summary Create or update a contact
 */
export const postContactsUpsert = (
    postContactsUpsertBody: BodyType<PostContactsUpsertBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Contact | Contact>(
      {url: `/contacts/upsert`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postContactsUpsertBody, signal
    },
      options);
    }
  


export const getPostContactsUpsertMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContactsUpsert>>, TError,{data: BodyType<PostContactsUpsertBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postContactsUpsert>>, TError,{data: BodyType<PostContactsUpsertBody>}, TContext> => {

const mutationKey = ['postContactsUpsert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsUpsert>>, {data: BodyType<PostContactsUpsertBody>}> = (props) => {
          const {data} = props ?? {};

          return  postContactsUpsert(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostContactsUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof postContactsUpsert>>>
    export type PostContactsUpsertMutationBody = BodyType<PostContactsUpsertBody>
    export type PostContactsUpsertMutationError = ErrorType<void>

    /**
 * @summary Create or update a contact
 */
export const usePostContactsUpsert = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContactsUpsert>>, TError,{data: BodyType<PostContactsUpsertBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postContactsUpsert>>,
        TError,
        {data: BodyType<PostContactsUpsertBody>},
        TContext
      > => {

      const mutationOptions = getPostContactsUpsertMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates a new contact entry of type `candidate` with source `resume`. The authenticated user's organization_id is required.

 * @summary Create a candidate contact from a resume
 */
export const postContactsCandidate = (
    postContactsCandidateBody: BodyType<PostContactsCandidateBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostContactsCandidate201>(
      {url: `/contacts/candidate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postContactsCandidateBody, signal
    },
      options);
    }
  


export const getPostContactsCandidateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContactsCandidate>>, TError,{data: BodyType<PostContactsCandidateBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postContactsCandidate>>, TError,{data: BodyType<PostContactsCandidateBody>}, TContext> => {

const mutationKey = ['postContactsCandidate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsCandidate>>, {data: BodyType<PostContactsCandidateBody>}> = (props) => {
          const {data} = props ?? {};

          return  postContactsCandidate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostContactsCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof postContactsCandidate>>>
    export type PostContactsCandidateMutationBody = BodyType<PostContactsCandidateBody>
    export type PostContactsCandidateMutationError = ErrorType<void>

    /**
 * @summary Create a candidate contact from a resume
 */
export const usePostContactsCandidate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContactsCandidate>>, TError,{data: BodyType<PostContactsCandidateBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postContactsCandidate>>,
        TError,
        {data: BodyType<PostContactsCandidateBody>},
        TContext
      > => {

      const mutationOptions = getPostContactsCandidateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns a list of buckets linked to a specific contact within the authenticated user's organization.
The endpoint queries the `bucket_contacts` table and joins bucket details from the `buckets` table.

 * @summary Retrieve all buckets associated with a contact
 */
export const getContactsContactIdBuckets = (
    contactId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetContactsContactIdBuckets200Item[]>(
      {url: `/contacts/${contactId}/buckets`, method: 'GET', signal
    },
      options);
    }
  



export const getGetContactsContactIdBucketsQueryKey = (contactId?: string,) => {
    return [
    `/contacts/${contactId}/buckets`
    ] as const;
    }

    
export const getGetContactsContactIdBucketsQueryOptions = <TData = Awaited<ReturnType<typeof getContactsContactIdBuckets>>, TError = ErrorType<void>>(contactId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactsContactIdBuckets>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContactsContactIdBucketsQueryKey(contactId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactsContactIdBuckets>>> = ({ signal }) => getContactsContactIdBuckets(contactId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contactId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContactsContactIdBuckets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContactsContactIdBucketsQueryResult = NonNullable<Awaited<ReturnType<typeof getContactsContactIdBuckets>>>
export type GetContactsContactIdBucketsQueryError = ErrorType<void>


export function useGetContactsContactIdBuckets<TData = Awaited<ReturnType<typeof getContactsContactIdBuckets>>, TError = ErrorType<void>>(
 contactId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactsContactIdBuckets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactsContactIdBuckets>>,
          TError,
          Awaited<ReturnType<typeof getContactsContactIdBuckets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContactsContactIdBuckets<TData = Awaited<ReturnType<typeof getContactsContactIdBuckets>>, TError = ErrorType<void>>(
 contactId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactsContactIdBuckets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactsContactIdBuckets>>,
          TError,
          Awaited<ReturnType<typeof getContactsContactIdBuckets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContactsContactIdBuckets<TData = Awaited<ReturnType<typeof getContactsContactIdBuckets>>, TError = ErrorType<void>>(
 contactId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactsContactIdBuckets>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve all buckets associated with a contact
 */

export function useGetContactsContactIdBuckets<TData = Awaited<ReturnType<typeof getContactsContactIdBuckets>>, TError = ErrorType<void>>(
 contactId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactsContactIdBuckets>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContactsContactIdBucketsQueryOptions(contactId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update an existing contact's details.
 * @summary Update a contact
 */
export const putContactsContactId = (
    contactId: string,
    putContactsContactIdBody: BodyType<PutContactsContactIdBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<Contact>(
      {url: `/contacts/${contactId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putContactsContactIdBody
    },
      options);
    }
  


export const getPutContactsContactIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putContactsContactId>>, TError,{contactId: string;data: BodyType<PutContactsContactIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putContactsContactId>>, TError,{contactId: string;data: BodyType<PutContactsContactIdBody>}, TContext> => {

const mutationKey = ['putContactsContactId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putContactsContactId>>, {contactId: string;data: BodyType<PutContactsContactIdBody>}> = (props) => {
          const {contactId,data} = props ?? {};

          return  putContactsContactId(contactId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutContactsContactIdMutationResult = NonNullable<Awaited<ReturnType<typeof putContactsContactId>>>
    export type PutContactsContactIdMutationBody = BodyType<PutContactsContactIdBody>
    export type PutContactsContactIdMutationError = ErrorType<void>

    /**
 * @summary Update a contact
 */
export const usePutContactsContactId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putContactsContactId>>, TError,{contactId: string;data: BodyType<PutContactsContactIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putContactsContactId>>,
        TError,
        {contactId: string;data: BodyType<PutContactsContactIdBody>},
        TContext
      > => {

      const mutationOptions = getPutContactsContactIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Sends an email record to the specified recipient.
If no contact exists (`contact_id` is null), a new contact will be created.
If a `job_id` and `candidate_id` are provided, the corresponding `job_candidates.contact_id` will be updated (only if currently null).

 * @summary Send an email and optionally create or link a contact
 */
export const postEmailsSendEmail = (
    postEmailsSendEmailBody: BodyType<PostEmailsSendEmailBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostEmailsSendEmail200>(
      {url: `/emails/send-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postEmailsSendEmailBody, signal
    },
      options);
    }
  


export const getPostEmailsSendEmailMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmailsSendEmail>>, TError,{data: BodyType<PostEmailsSendEmailBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmailsSendEmail>>, TError,{data: BodyType<PostEmailsSendEmailBody>}, TContext> => {

const mutationKey = ['postEmailsSendEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmailsSendEmail>>, {data: BodyType<PostEmailsSendEmailBody>}> = (props) => {
          const {data} = props ?? {};

          return  postEmailsSendEmail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmailsSendEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postEmailsSendEmail>>>
    export type PostEmailsSendEmailMutationBody = BodyType<PostEmailsSendEmailBody>
    export type PostEmailsSendEmailMutationError = ErrorType<void>

    /**
 * @summary Send an email and optionally create or link a contact
 */
export const usePostEmailsSendEmail = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmailsSendEmail>>, TError,{data: BodyType<PostEmailsSendEmailBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmailsSendEmail>>,
        TError,
        {data: BodyType<PostEmailsSendEmailBody>},
        TContext
      > => {

      const mutationOptions = getPostEmailsSendEmailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns all emails created by the authenticated user within their organization.
Optionally filters by job ID. Results are sorted by `sent_at` in descending order
(most recent first).

 * @summary Retrieve emails sent by the current user
 */
export const getEmails = (
    params?: GetEmailsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Email[]>(
      {url: `/emails`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetEmailsQueryKey = (params?: GetEmailsParams,) => {
    return [
    `/emails`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEmailsQueryOptions = <TData = Awaited<ReturnType<typeof getEmails>>, TError = ErrorType<void>>(params?: GetEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmails>>> = ({ signal }) => getEmails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmails>>>
export type GetEmailsQueryError = ErrorType<void>


export function useGetEmails<TData = Awaited<ReturnType<typeof getEmails>>, TError = ErrorType<void>>(
 params: undefined |  GetEmailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmails>>,
          TError,
          Awaited<ReturnType<typeof getEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmails<TData = Awaited<ReturnType<typeof getEmails>>, TError = ErrorType<void>>(
 params?: GetEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmails>>,
          TError,
          Awaited<ReturnType<typeof getEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmails<TData = Awaited<ReturnType<typeof getEmails>>, TError = ErrorType<void>>(
 params?: GetEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve emails sent by the current user
 */

export function useGetEmails<TData = Awaited<ReturnType<typeof getEmails>>, TError = ErrorType<void>>(
 params?: GetEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List events for current user
 */
export const getEvents = (
    params?: GetEventsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetEvents200>(
      {url: `/events`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetEventsQueryKey = (params?: GetEventsParams,) => {
    return [
    `/events`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEventsQueryOptions = <TData = Awaited<ReturnType<typeof getEvents>>, TError = ErrorType<unknown>>(params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>> = ({ signal }) => getEvents(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvents>>>
export type GetEventsQueryError = ErrorType<unknown>


export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = ErrorType<unknown>>(
 params: undefined |  GetEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = ErrorType<unknown>>(
 params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = ErrorType<unknown>>(
 params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List events for current user
 */

export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = ErrorType<unknown>>(
 params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create an event
 */
export const postEvents = (
    eventCreate: BodyType<EventCreate>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostEvents201>(
      {url: `/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eventCreate, signal
    },
      options);
    }
  


export const getPostEventsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEvents>>, TError,{data: BodyType<EventCreate>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postEvents>>, TError,{data: BodyType<EventCreate>}, TContext> => {

const mutationKey = ['postEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEvents>>, {data: BodyType<EventCreate>}> = (props) => {
          const {data} = props ?? {};

          return  postEvents(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEventsMutationResult = NonNullable<Awaited<ReturnType<typeof postEvents>>>
    export type PostEventsMutationBody = BodyType<EventCreate>
    export type PostEventsMutationError = ErrorType<unknown>

    /**
 * @summary Create an event
 */
export const usePostEvents = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEvents>>, TError,{data: BodyType<EventCreate>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEvents>>,
        TError,
        {data: BodyType<EventCreate>},
        TContext
      > => {

      const mutationOptions = getPostEventsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Resolve authenticated user's email credential provider
 */
export const getEventsProvider = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetEventsProvider200>(
      {url: `/events/provider`, method: 'GET', signal
    },
      options);
    }
  



export const getGetEventsProviderQueryKey = () => {
    return [
    `/events/provider`
    ] as const;
    }

    
export const getGetEventsProviderQueryOptions = <TData = Awaited<ReturnType<typeof getEventsProvider>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsProvider>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsProviderQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventsProvider>>> = ({ signal }) => getEventsProvider(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventsProvider>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsProviderQueryResult = NonNullable<Awaited<ReturnType<typeof getEventsProvider>>>
export type GetEventsProviderQueryError = ErrorType<void>


export function useGetEventsProvider<TData = Awaited<ReturnType<typeof getEventsProvider>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsProvider>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsProvider>>,
          TError,
          Awaited<ReturnType<typeof getEventsProvider>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsProvider<TData = Awaited<ReturnType<typeof getEventsProvider>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsProvider>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsProvider>>,
          TError,
          Awaited<ReturnType<typeof getEventsProvider>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsProvider<TData = Awaited<ReturnType<typeof getEventsProvider>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsProvider>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolve authenticated user's email credential provider
 */

export function useGetEventsProvider<TData = Awaited<ReturnType<typeof getEventsProvider>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsProvider>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsProviderQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get busy time slots for authenticated user's calendar
 */
export const getEventsBusySlots = (
    params?: GetEventsBusySlotsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetEventsBusySlots200>(
      {url: `/events/busy-slots`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetEventsBusySlotsQueryKey = (params?: GetEventsBusySlotsParams,) => {
    return [
    `/events/busy-slots`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEventsBusySlotsQueryOptions = <TData = Awaited<ReturnType<typeof getEventsBusySlots>>, TError = ErrorType<void>>(params?: GetEventsBusySlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsBusySlots>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsBusySlotsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventsBusySlots>>> = ({ signal }) => getEventsBusySlots(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventsBusySlots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsBusySlotsQueryResult = NonNullable<Awaited<ReturnType<typeof getEventsBusySlots>>>
export type GetEventsBusySlotsQueryError = ErrorType<void>


export function useGetEventsBusySlots<TData = Awaited<ReturnType<typeof getEventsBusySlots>>, TError = ErrorType<void>>(
 params: undefined |  GetEventsBusySlotsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsBusySlots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsBusySlots>>,
          TError,
          Awaited<ReturnType<typeof getEventsBusySlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsBusySlots<TData = Awaited<ReturnType<typeof getEventsBusySlots>>, TError = ErrorType<void>>(
 params?: GetEventsBusySlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsBusySlots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsBusySlots>>,
          TError,
          Awaited<ReturnType<typeof getEventsBusySlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsBusySlots<TData = Awaited<ReturnType<typeof getEventsBusySlots>>, TError = ErrorType<void>>(
 params?: GetEventsBusySlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsBusySlots>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get busy time slots for authenticated user's calendar
 */

export function useGetEventsBusySlots<TData = Awaited<ReturnType<typeof getEventsBusySlots>>, TError = ErrorType<void>>(
 params?: GetEventsBusySlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsBusySlots>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsBusySlotsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get single event
 */
export const getId = (
    id: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetId200>(
      {url: `/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIdQueryKey = (id?: string,) => {
    return [
    `/${id}`
    ] as const;
    }

    
export const getGetIdQueryOptions = <TData = Awaited<ReturnType<typeof getId>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getId>>> = ({ signal }) => getId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIdQueryResult = NonNullable<Awaited<ReturnType<typeof getId>>>
export type GetIdQueryError = ErrorType<void>


export function useGetId<TData = Awaited<ReturnType<typeof getId>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getId>>,
          TError,
          Awaited<ReturnType<typeof getId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetId<TData = Awaited<ReturnType<typeof getId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getId>>,
          TError,
          Awaited<ReturnType<typeof getId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetId<TData = Awaited<ReturnType<typeof getId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get single event
 */

export function useGetId<TData = Awaited<ReturnType<typeof getId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update an event
 */
export const putEventsId = (
    id: string,
    eventUpdate: BodyType<EventUpdate>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/events/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: eventUpdate
    },
      options);
    }
  


export const getPutEventsIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEventsId>>, TError,{id: string;data: BodyType<EventUpdate>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putEventsId>>, TError,{id: string;data: BodyType<EventUpdate>}, TContext> => {

const mutationKey = ['putEventsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEventsId>>, {id: string;data: BodyType<EventUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  putEventsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEventsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEventsId>>>
    export type PutEventsIdMutationBody = BodyType<EventUpdate>
    export type PutEventsIdMutationError = ErrorType<void>

    /**
 * @summary Update an event
 */
export const usePutEventsId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEventsId>>, TError,{id: string;data: BodyType<EventUpdate>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEventsId>>,
        TError,
        {id: string;data: BodyType<EventUpdate>},
        TContext
      > => {

      const mutationOptions = getPutEventsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete an event
 */
export const deleteEventsId = (
    id: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/events/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteEventsIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEventsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteEventsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEventsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEventsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEventsId>>>
    
    export type DeleteEventsIdMutationError = ErrorType<void>

    /**
 * @summary Delete an event
 */
export const useDeleteEventsId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEventsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEventsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Uploads a file to S3 and creates a record in the corresponding table. - `owner=job` -> writes to **job_files** - `owner=job_candidate` -> writes to **candidate_files**

 * @summary Upload a file for a job or job candidate
 */
export const postFilesOwnerOwnerId = (
    owner: 'job' | 'candidate',
    ownerId: string,
    postFilesOwnerOwnerIdBody: BodyType<PostFilesOwnerOwnerIdBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(postFilesOwnerOwnerIdBody.file !== undefined) {
 formData.append(`file`, postFilesOwnerOwnerIdBody.file)
 }
if(postFilesOwnerOwnerIdBody.category !== undefined) {
 formData.append(`category`, postFilesOwnerOwnerIdBody.category)
 }
if(postFilesOwnerOwnerIdBody.jobId !== undefined) {
 formData.append(`jobId`, postFilesOwnerOwnerIdBody.jobId)
 }
if(postFilesOwnerOwnerIdBody.name !== undefined) {
 formData.append(`name`, postFilesOwnerOwnerIdBody.name)
 }

      return customClient<PostFilesOwnerOwnerId201>(
      {url: `/files/${owner}/${ownerId}`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getPostFilesOwnerOwnerIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFilesOwnerOwnerId>>, TError,{owner: 'job' | 'candidate';ownerId: string;data: BodyType<PostFilesOwnerOwnerIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postFilesOwnerOwnerId>>, TError,{owner: 'job' | 'candidate';ownerId: string;data: BodyType<PostFilesOwnerOwnerIdBody>}, TContext> => {

const mutationKey = ['postFilesOwnerOwnerId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFilesOwnerOwnerId>>, {owner: 'job' | 'candidate';ownerId: string;data: BodyType<PostFilesOwnerOwnerIdBody>}> = (props) => {
          const {owner,ownerId,data} = props ?? {};

          return  postFilesOwnerOwnerId(owner,ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFilesOwnerOwnerIdMutationResult = NonNullable<Awaited<ReturnType<typeof postFilesOwnerOwnerId>>>
    export type PostFilesOwnerOwnerIdMutationBody = BodyType<PostFilesOwnerOwnerIdBody>
    export type PostFilesOwnerOwnerIdMutationError = ErrorType<void>

    /**
 * @summary Upload a file for a job or job candidate
 */
export const usePostFilesOwnerOwnerId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFilesOwnerOwnerId>>, TError,{owner: 'job' | 'candidate';ownerId: string;data: BodyType<PostFilesOwnerOwnerIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postFilesOwnerOwnerId>>,
        TError,
        {owner: 'job' | 'candidate';ownerId: string;data: BodyType<PostFilesOwnerOwnerIdBody>},
        TContext
      > => {

      const mutationOptions = getPostFilesOwnerOwnerIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns a short-lived S3 presigned URL for downloading a file that was previously uploaded. - `owner=job` -> reads from **job_files.file_url** - `owner=job_candidate` -> reads from **candidate_files.storage_path**

 * @summary Get a presigned URL for a stored file
 */
export const getFilesOwnerFileIdPresign = (
    owner: 'job' | 'candidate',
    fileId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetFilesOwnerFileIdPresign200>(
      {url: `/files/${owner}/${fileId}/presign`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFilesOwnerFileIdPresignQueryKey = (owner?: 'job' | 'candidate',
    fileId?: string,) => {
    return [
    `/files/${owner}/${fileId}/presign`
    ] as const;
    }

    
export const getGetFilesOwnerFileIdPresignQueryOptions = <TData = Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>, TError = ErrorType<void>>(owner: 'job' | 'candidate',
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFilesOwnerFileIdPresignQueryKey(owner,fileId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>> = ({ signal }) => getFilesOwnerFileIdPresign(owner,fileId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(owner && fileId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFilesOwnerFileIdPresignQueryResult = NonNullable<Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>>
export type GetFilesOwnerFileIdPresignQueryError = ErrorType<void>


export function useGetFilesOwnerFileIdPresign<TData = Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>, TError = ErrorType<void>>(
 owner: 'job' | 'candidate',
    fileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>,
          TError,
          Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFilesOwnerFileIdPresign<TData = Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>, TError = ErrorType<void>>(
 owner: 'job' | 'candidate',
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>,
          TError,
          Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFilesOwnerFileIdPresign<TData = Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>, TError = ErrorType<void>>(
 owner: 'job' | 'candidate',
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a presigned URL for a stored file
 */

export function useGetFilesOwnerFileIdPresign<TData = Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>, TError = ErrorType<void>>(
 owner: 'job' | 'candidate',
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilesOwnerFileIdPresign>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFilesOwnerFileIdPresignQueryOptions(owner,fileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates the file_name field in the corresponding file record.

 * @summary Update the name of a file record
 */
export const putFilesFileIdRename = (
    fileId: string,
    putFilesFileIdRenameBody: BodyType<PutFilesFileIdRenameBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<PutFilesFileIdRename200>(
      {url: `/files/${fileId}/rename`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putFilesFileIdRenameBody
    },
      options);
    }
  


export const getPutFilesFileIdRenameMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putFilesFileIdRename>>, TError,{fileId: string;data: BodyType<PutFilesFileIdRenameBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putFilesFileIdRename>>, TError,{fileId: string;data: BodyType<PutFilesFileIdRenameBody>}, TContext> => {

const mutationKey = ['putFilesFileIdRename'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putFilesFileIdRename>>, {fileId: string;data: BodyType<PutFilesFileIdRenameBody>}> = (props) => {
          const {fileId,data} = props ?? {};

          return  putFilesFileIdRename(fileId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutFilesFileIdRenameMutationResult = NonNullable<Awaited<ReturnType<typeof putFilesFileIdRename>>>
    export type PutFilesFileIdRenameMutationBody = BodyType<PutFilesFileIdRenameBody>
    export type PutFilesFileIdRenameMutationError = ErrorType<unknown>

    /**
 * @summary Update the name of a file record
 */
export const usePutFilesFileIdRename = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putFilesFileIdRename>>, TError,{fileId: string;data: BodyType<PutFilesFileIdRenameBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putFilesFileIdRename>>,
        TError,
        {fileId: string;data: BodyType<PutFilesFileIdRenameBody>},
        TContext
      > => {

      const mutationOptions = getPutFilesFileIdRenameMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Deletes the file record from the appropriate table (`job_files` or `candidate_files`) and removes the associated object from S3 storage. Access is restricted to users belonging to the same organization as the file record.

 * @summary Delete a file record and its S3 stored object
 */
export const deleteFilesOwnerFileId = (
    owner: 'job' | 'candidate',
    fileId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<DeleteFilesOwnerFileId200>(
      {url: `/files/${owner}/${fileId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteFilesOwnerFileIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFilesOwnerFileId>>, TError,{owner: 'job' | 'candidate';fileId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFilesOwnerFileId>>, TError,{owner: 'job' | 'candidate';fileId: string}, TContext> => {

const mutationKey = ['deleteFilesOwnerFileId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFilesOwnerFileId>>, {owner: 'job' | 'candidate';fileId: string}> = (props) => {
          const {owner,fileId} = props ?? {};

          return  deleteFilesOwnerFileId(owner,fileId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFilesOwnerFileIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFilesOwnerFileId>>>
    
    export type DeleteFilesOwnerFileIdMutationError = ErrorType<void>

    /**
 * @summary Delete a file record and its S3 stored object
 */
export const useDeleteFilesOwnerFileId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFilesOwnerFileId>>, TError,{owner: 'job' | 'candidate';fileId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFilesOwnerFileId>>,
        TError,
        {owner: 'job' | 'candidate';fileId: string},
        TContext
      > => {

      const mutationOptions = getDeleteFilesOwnerFileIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Starts a work email enrichment request for a given LinkedIn profile. - If the candidate already has contact data, returns it immediately. - Otherwise, transmits a GET request to EnrichLayer's `/profile/email` endpoint. - EnrichLayer will call back your `/webhooks/enrichlayer/contact` endpoint when the lookup completes.

 * @summary Initiate EnrichLayer work email lookup for a candidate
 */
export const postContactfinderEnrichlayerRequestEmail = (
    postContactfinderEnrichlayerRequestEmailBody: BodyType<PostContactfinderEnrichlayerRequestEmailBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostContactfinderEnrichlayerRequestEmail200 | PostContactfinderEnrichlayerRequestEmail202>(
      {url: `/contactfinder/enrichlayer/request-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postContactfinderEnrichlayerRequestEmailBody, signal
    },
      options);
    }
  


export const getPostContactfinderEnrichlayerRequestEmailMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContactfinderEnrichlayerRequestEmail>>, TError,{data: BodyType<PostContactfinderEnrichlayerRequestEmailBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postContactfinderEnrichlayerRequestEmail>>, TError,{data: BodyType<PostContactfinderEnrichlayerRequestEmailBody>}, TContext> => {

const mutationKey = ['postContactfinderEnrichlayerRequestEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactfinderEnrichlayerRequestEmail>>, {data: BodyType<PostContactfinderEnrichlayerRequestEmailBody>}> = (props) => {
          const {data} = props ?? {};

          return  postContactfinderEnrichlayerRequestEmail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostContactfinderEnrichlayerRequestEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postContactfinderEnrichlayerRequestEmail>>>
    export type PostContactfinderEnrichlayerRequestEmailMutationBody = BodyType<PostContactfinderEnrichlayerRequestEmailBody>
    export type PostContactfinderEnrichlayerRequestEmailMutationError = ErrorType<void>

    /**
 * @summary Initiate EnrichLayer work email lookup for a candidate
 */
export const usePostContactfinderEnrichlayerRequestEmail = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContactfinderEnrichlayerRequestEmail>>, TError,{data: BodyType<PostContactfinderEnrichlayerRequestEmailBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postContactfinderEnrichlayerRequestEmail>>,
        TError,
        {data: BodyType<PostContactfinderEnrichlayerRequestEmailBody>},
        TContext
      > => {

      const mutationOptions = getPostContactfinderEnrichlayerRequestEmailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Calls ContactOut with a LinkedIn profile URL, picks the best email (personal → work → generic), then inserts into `contacts`.
 * @summary Create a contact from a ContactOut LinkedIn lookup
 */
export const postContactfinderContactoutEnrichContact = (
    contactOutLinkedInCreateRequest: BodyType<ContactOutLinkedInCreateRequest>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<ContactOutLinkedInCreateResponse | ContactOutLinkedInCreateResponse>(
      {url: `/contactfinder/contactout/enrich_contact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contactOutLinkedInCreateRequest, signal
    },
      options);
    }
  


export const getPostContactfinderContactoutEnrichContactMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContactfinderContactoutEnrichContact>>, TError,{data: BodyType<ContactOutLinkedInCreateRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postContactfinderContactoutEnrichContact>>, TError,{data: BodyType<ContactOutLinkedInCreateRequest>}, TContext> => {

const mutationKey = ['postContactfinderContactoutEnrichContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactfinderContactoutEnrichContact>>, {data: BodyType<ContactOutLinkedInCreateRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postContactfinderContactoutEnrichContact(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostContactfinderContactoutEnrichContactMutationResult = NonNullable<Awaited<ReturnType<typeof postContactfinderContactoutEnrichContact>>>
    export type PostContactfinderContactoutEnrichContactMutationBody = BodyType<ContactOutLinkedInCreateRequest>
    export type PostContactfinderContactoutEnrichContactMutationError = ErrorType<void>

    /**
 * @summary Create a contact from a ContactOut LinkedIn lookup
 */
export const usePostContactfinderContactoutEnrichContact = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContactfinderContactoutEnrichContact>>, TError,{data: BodyType<ContactOutLinkedInCreateRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postContactfinderContactoutEnrichContact>>,
        TError,
        {data: BodyType<ContactOutLinkedInCreateRequest>},
        TContext
      > => {

      const mutationOptions = getPostContactfinderContactoutEnrichContactMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get the pipeline state for a job
 */
export const getJobsJobIdPipeline = (
    jobId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetJobsJobIdPipeline200>(
      {url: `/jobs/${jobId}/pipeline`, method: 'GET', signal
    },
      options);
    }
  



export const getGetJobsJobIdPipelineQueryKey = (jobId?: string,) => {
    return [
    `/jobs/${jobId}/pipeline`
    ] as const;
    }

    
export const getGetJobsJobIdPipelineQueryOptions = <TData = Awaited<ReturnType<typeof getJobsJobIdPipeline>>, TError = ErrorType<unknown>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipeline>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsJobIdPipelineQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdPipeline>>> = ({ signal }) => getJobsJobIdPipeline(jobId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobsJobIdPipelineQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsJobIdPipeline>>>
export type GetJobsJobIdPipelineQueryError = ErrorType<unknown>


export function useGetJobsJobIdPipeline<TData = Awaited<ReturnType<typeof getJobsJobIdPipeline>>, TError = ErrorType<unknown>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipeline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobIdPipeline>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobIdPipeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobIdPipeline<TData = Awaited<ReturnType<typeof getJobsJobIdPipeline>>, TError = ErrorType<unknown>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipeline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobIdPipeline>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobIdPipeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobIdPipeline<TData = Awaited<ReturnType<typeof getJobsJobIdPipeline>>, TError = ErrorType<unknown>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipeline>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the pipeline state for a job
 */

export function useGetJobsJobIdPipeline<TData = Awaited<ReturnType<typeof getJobsJobIdPipeline>>, TError = ErrorType<unknown>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipeline>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobsJobIdPipelineQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns a list of jobs for the authenticated user's organization.  
Each job includes:
- Its metadata (title, status, etc.)
- Related `job_candidates` with their `state`
- Aggregated counts:
  - **applicants**: total number of job_candidates
  - **interviews**: number of candidates with `state = "interviewing"`

 * @summary Retrieve paginated job items with pipeline information
 */
export const getJobs = (
    params?: GetJobsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Job[]>(
      {url: `/jobs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetJobsQueryKey = (params?: GetJobsParams,) => {
    return [
    `/jobs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetJobsQueryOptions = <TData = Awaited<ReturnType<typeof getJobs>>, TError = ErrorType<unknown>>(params?: GetJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobs>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobs>>> = ({ signal }) => getJobs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobs>>>
export type GetJobsQueryError = ErrorType<unknown>


export function useGetJobs<TData = Awaited<ReturnType<typeof getJobs>>, TError = ErrorType<unknown>>(
 params: undefined |  GetJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobs>>,
          TError,
          Awaited<ReturnType<typeof getJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobs<TData = Awaited<ReturnType<typeof getJobs>>, TError = ErrorType<unknown>>(
 params?: GetJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobs>>,
          TError,
          Awaited<ReturnType<typeof getJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobs<TData = Awaited<ReturnType<typeof getJobs>>, TError = ErrorType<unknown>>(
 params?: GetJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobs>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve paginated job items with pipeline information
 */

export function useGetJobs<TData = Awaited<ReturnType<typeof getJobs>>, TError = ErrorType<unknown>>(
 params?: GetJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobs>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a new job
 */
export const postJobs = (
    postJobsBody: BodyType<PostJobsBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostJobs201>(
      {url: `/jobs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postJobsBody, signal
    },
      options);
    }
  


export const getPostJobsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postJobs>>, TError,{data: BodyType<PostJobsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postJobs>>, TError,{data: BodyType<PostJobsBody>}, TContext> => {

const mutationKey = ['postJobs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postJobs>>, {data: BodyType<PostJobsBody>}> = (props) => {
          const {data} = props ?? {};

          return  postJobs(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostJobsMutationResult = NonNullable<Awaited<ReturnType<typeof postJobs>>>
    export type PostJobsMutationBody = BodyType<PostJobsBody>
    export type PostJobsMutationError = ErrorType<unknown>

    /**
 * @summary Create a new job
 */
export const usePostJobs = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postJobs>>, TError,{data: BodyType<PostJobsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postJobs>>,
        TError,
        {data: BodyType<PostJobsBody>},
        TContext
      > => {

      const mutationOptions = getPostJobsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get a job by id
 */
export const getJobsJobId = (
    jobId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Job>(
      {url: `/jobs/${jobId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetJobsJobIdQueryKey = (jobId?: string,) => {
    return [
    `/jobs/${jobId}`
    ] as const;
    }

    
export const getGetJobsJobIdQueryOptions = <TData = Awaited<ReturnType<typeof getJobsJobId>>, TError = ErrorType<unknown>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsJobIdQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobId>>> = ({ signal }) => getJobsJobId(jobId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobsJobId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobsJobIdQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsJobId>>>
export type GetJobsJobIdQueryError = ErrorType<unknown>


export function useGetJobsJobId<TData = Awaited<ReturnType<typeof getJobsJobId>>, TError = ErrorType<unknown>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobId>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobId<TData = Awaited<ReturnType<typeof getJobsJobId>>, TError = ErrorType<unknown>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobId>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobId<TData = Awaited<ReturnType<typeof getJobsJobId>>, TError = ErrorType<unknown>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a job by id
 */

export function useGetJobsJobId<TData = Awaited<ReturnType<typeof getJobsJobId>>, TError = ErrorType<unknown>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobsJobIdQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update a job
 */
export const putJobsJobId = (
    jobId: string,
    putJobsJobIdBody: BodyType<PutJobsJobIdBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<PutJobsJobId201>(
      {url: `/jobs/${jobId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putJobsJobIdBody
    },
      options);
    }
  


export const getPutJobsJobIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putJobsJobId>>, TError,{jobId: string;data: BodyType<PutJobsJobIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putJobsJobId>>, TError,{jobId: string;data: BodyType<PutJobsJobIdBody>}, TContext> => {

const mutationKey = ['putJobsJobId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putJobsJobId>>, {jobId: string;data: BodyType<PutJobsJobIdBody>}> = (props) => {
          const {jobId,data} = props ?? {};

          return  putJobsJobId(jobId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutJobsJobIdMutationResult = NonNullable<Awaited<ReturnType<typeof putJobsJobId>>>
    export type PutJobsJobIdMutationBody = BodyType<PutJobsJobIdBody>
    export type PutJobsJobIdMutationError = ErrorType<unknown>

    /**
 * @summary Update a job
 */
export const usePutJobsJobId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putJobsJobId>>, TError,{jobId: string;data: BodyType<PutJobsJobIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putJobsJobId>>,
        TError,
        {jobId: string;data: BodyType<PutJobsJobIdBody>},
        TContext
      > => {

      const mutationOptions = getPutJobsJobIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Adds one or more candidates to a specific job's pipeline.   Supports bulk insertion and returns a summary indicating which candidates were successfully added.

 * @summary Add one or more candidates to a job pipeline
 */
export const postJobsJobIdPipelineAdd = (
    jobId: string,
    postJobsJobIdPipelineAddBody: BodyType<PostJobsJobIdPipelineAddBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostJobsJobIdPipelineAdd201 | PostJobsJobIdPipelineAdd207>(
      {url: `/jobs/${jobId}/pipeline/add`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postJobsJobIdPipelineAddBody, signal
    },
      options);
    }
  


export const getPostJobsJobIdPipelineAddMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postJobsJobIdPipelineAdd>>, TError,{jobId: string;data: BodyType<PostJobsJobIdPipelineAddBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postJobsJobIdPipelineAdd>>, TError,{jobId: string;data: BodyType<PostJobsJobIdPipelineAddBody>}, TContext> => {

const mutationKey = ['postJobsJobIdPipelineAdd'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postJobsJobIdPipelineAdd>>, {jobId: string;data: BodyType<PostJobsJobIdPipelineAddBody>}> = (props) => {
          const {jobId,data} = props ?? {};

          return  postJobsJobIdPipelineAdd(jobId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostJobsJobIdPipelineAddMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsJobIdPipelineAdd>>>
    export type PostJobsJobIdPipelineAddMutationBody = BodyType<PostJobsJobIdPipelineAddBody>
    export type PostJobsJobIdPipelineAddMutationError = ErrorType<unknown>

    /**
 * @summary Add one or more candidates to a job pipeline
 */
export const usePostJobsJobIdPipelineAdd = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postJobsJobIdPipelineAdd>>, TError,{jobId: string;data: BodyType<PostJobsJobIdPipelineAddBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postJobsJobIdPipelineAdd>>,
        TError,
        {jobId: string;data: BodyType<PostJobsJobIdPipelineAddBody>},
        TContext
      > => {

      const mutationOptions = getPostJobsJobIdPipelineAddMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Validates the body against StructuredResumeCandidateSchema, upserts the candidate (Supabase RPC `upsert_candidate`), then attaches the candidate to the specified job at the `longlist` stage.

 * @summary Add a candidate to a job pipeline from a parsed resume
 */
export const postJobsJobIdPipelineResumeAdd = (
    jobId: string,
    structuredResumeCandidate: BodyType<StructuredResumeCandidate>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<JobCandidate>(
      {url: `/jobs/${jobId}/pipeline/resume_add`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: structuredResumeCandidate, signal
    },
      options);
    }
  


export const getPostJobsJobIdPipelineResumeAddMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postJobsJobIdPipelineResumeAdd>>, TError,{jobId: string;data: BodyType<StructuredResumeCandidate>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postJobsJobIdPipelineResumeAdd>>, TError,{jobId: string;data: BodyType<StructuredResumeCandidate>}, TContext> => {

const mutationKey = ['postJobsJobIdPipelineResumeAdd'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postJobsJobIdPipelineResumeAdd>>, {jobId: string;data: BodyType<StructuredResumeCandidate>}> = (props) => {
          const {jobId,data} = props ?? {};

          return  postJobsJobIdPipelineResumeAdd(jobId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostJobsJobIdPipelineResumeAddMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsJobIdPipelineResumeAdd>>>
    export type PostJobsJobIdPipelineResumeAddMutationBody = BodyType<StructuredResumeCandidate>
    export type PostJobsJobIdPipelineResumeAddMutationError = ErrorType<void>

    /**
 * @summary Add a candidate to a job pipeline from a parsed resume
 */
export const usePostJobsJobIdPipelineResumeAdd = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postJobsJobIdPipelineResumeAdd>>, TError,{jobId: string;data: BodyType<StructuredResumeCandidate>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postJobsJobIdPipelineResumeAdd>>,
        TError,
        {jobId: string;data: BodyType<StructuredResumeCandidate>},
        TContext
      > => {

      const mutationOptions = getPostJobsJobIdPipelineResumeAddMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Move a job candidate to a different pipeline stage
 */
export const putJobsJobIdPipelineStage = (
    jobId: string,
    putJobsJobIdPipelineStageBody: BodyType<PutJobsJobIdPipelineStageBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<PutJobsJobIdPipelineStage200>(
      {url: `/jobs/${jobId}/pipeline/stage`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putJobsJobIdPipelineStageBody
    },
      options);
    }
  


export const getPutJobsJobIdPipelineStageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putJobsJobIdPipelineStage>>, TError,{jobId: string;data: BodyType<PutJobsJobIdPipelineStageBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putJobsJobIdPipelineStage>>, TError,{jobId: string;data: BodyType<PutJobsJobIdPipelineStageBody>}, TContext> => {

const mutationKey = ['putJobsJobIdPipelineStage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putJobsJobIdPipelineStage>>, {jobId: string;data: BodyType<PutJobsJobIdPipelineStageBody>}> = (props) => {
          const {jobId,data} = props ?? {};

          return  putJobsJobIdPipelineStage(jobId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutJobsJobIdPipelineStageMutationResult = NonNullable<Awaited<ReturnType<typeof putJobsJobIdPipelineStage>>>
    export type PutJobsJobIdPipelineStageMutationBody = BodyType<PutJobsJobIdPipelineStageBody>
    export type PutJobsJobIdPipelineStageMutationError = ErrorType<unknown>

    /**
 * @summary Move a job candidate to a different pipeline stage
 */
export const usePutJobsJobIdPipelineStage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putJobsJobIdPipelineStage>>, TError,{jobId: string;data: BodyType<PutJobsJobIdPipelineStageBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putJobsJobIdPipelineStage>>,
        TError,
        {jobId: string;data: BodyType<PutJobsJobIdPipelineStageBody>},
        TContext
      > => {

      const mutationOptions = getPutJobsJobIdPipelineStageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Add a comment to a job candidate pipeline
 */
export const postJobsJobIdPipelineComments = (
    jobId: string,
    postJobsJobIdPipelineCommentsBody: BodyType<PostJobsJobIdPipelineCommentsBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostJobsJobIdPipelineComments201>(
      {url: `/jobs/${jobId}/pipeline/comments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postJobsJobIdPipelineCommentsBody, signal
    },
      options);
    }
  


export const getPostJobsJobIdPipelineCommentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postJobsJobIdPipelineComments>>, TError,{jobId: string;data: BodyType<PostJobsJobIdPipelineCommentsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postJobsJobIdPipelineComments>>, TError,{jobId: string;data: BodyType<PostJobsJobIdPipelineCommentsBody>}, TContext> => {

const mutationKey = ['postJobsJobIdPipelineComments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postJobsJobIdPipelineComments>>, {jobId: string;data: BodyType<PostJobsJobIdPipelineCommentsBody>}> = (props) => {
          const {jobId,data} = props ?? {};

          return  postJobsJobIdPipelineComments(jobId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostJobsJobIdPipelineCommentsMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsJobIdPipelineComments>>>
    export type PostJobsJobIdPipelineCommentsMutationBody = BodyType<PostJobsJobIdPipelineCommentsBody>
    export type PostJobsJobIdPipelineCommentsMutationError = ErrorType<unknown>

    /**
 * @summary Add a comment to a job candidate pipeline
 */
export const usePostJobsJobIdPipelineComments = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postJobsJobIdPipelineComments>>, TError,{jobId: string;data: BodyType<PostJobsJobIdPipelineCommentsBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postJobsJobIdPipelineComments>>,
        TError,
        {jobId: string;data: BodyType<PostJobsJobIdPipelineCommentsBody>},
        TContext
      > => {

      const mutationOptions = getPostJobsJobIdPipelineCommentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List comments on candidates in a job pipeline
 */
export const getJobsJobIdPipelineComments = (
    jobId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetJobsJobIdPipelineComments200Item[]>(
      {url: `/jobs/${jobId}/pipeline/comments`, method: 'GET', signal
    },
      options);
    }
  



export const getGetJobsJobIdPipelineCommentsQueryKey = (jobId?: string,) => {
    return [
    `/jobs/${jobId}/pipeline/comments`
    ] as const;
    }

    
export const getGetJobsJobIdPipelineCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>, TError = ErrorType<unknown>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsJobIdPipelineCommentsQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>> = ({ signal }) => getJobsJobIdPipelineComments(jobId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobsJobIdPipelineCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>>
export type GetJobsJobIdPipelineCommentsQueryError = ErrorType<unknown>


export function useGetJobsJobIdPipelineComments<TData = Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>, TError = ErrorType<unknown>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobIdPipelineComments<TData = Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>, TError = ErrorType<unknown>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobIdPipelineComments<TData = Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>, TError = ErrorType<unknown>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List comments on candidates in a job pipeline
 */

export function useGetJobsJobIdPipelineComments<TData = Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>, TError = ErrorType<unknown>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipelineComments>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobsJobIdPipelineCommentsQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Edit a job candidate comment
 */
export const putJobsJobIdPipelineCommentsCommentId = (
    jobId: string,
    commentId: string,
    putJobsJobIdPipelineCommentsCommentIdBody: BodyType<PutJobsJobIdPipelineCommentsCommentIdBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<PutJobsJobIdPipelineCommentsCommentId200>(
      {url: `/jobs/${jobId}/pipeline/comments/${commentId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putJobsJobIdPipelineCommentsCommentIdBody
    },
      options);
    }
  


export const getPutJobsJobIdPipelineCommentsCommentIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putJobsJobIdPipelineCommentsCommentId>>, TError,{jobId: string;commentId: string;data: BodyType<PutJobsJobIdPipelineCommentsCommentIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putJobsJobIdPipelineCommentsCommentId>>, TError,{jobId: string;commentId: string;data: BodyType<PutJobsJobIdPipelineCommentsCommentIdBody>}, TContext> => {

const mutationKey = ['putJobsJobIdPipelineCommentsCommentId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putJobsJobIdPipelineCommentsCommentId>>, {jobId: string;commentId: string;data: BodyType<PutJobsJobIdPipelineCommentsCommentIdBody>}> = (props) => {
          const {jobId,commentId,data} = props ?? {};

          return  putJobsJobIdPipelineCommentsCommentId(jobId,commentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutJobsJobIdPipelineCommentsCommentIdMutationResult = NonNullable<Awaited<ReturnType<typeof putJobsJobIdPipelineCommentsCommentId>>>
    export type PutJobsJobIdPipelineCommentsCommentIdMutationBody = BodyType<PutJobsJobIdPipelineCommentsCommentIdBody>
    export type PutJobsJobIdPipelineCommentsCommentIdMutationError = ErrorType<unknown>

    /**
 * @summary Edit a job candidate comment
 */
export const usePutJobsJobIdPipelineCommentsCommentId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putJobsJobIdPipelineCommentsCommentId>>, TError,{jobId: string;commentId: string;data: BodyType<PutJobsJobIdPipelineCommentsCommentIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putJobsJobIdPipelineCommentsCommentId>>,
        TError,
        {jobId: string;commentId: string;data: BodyType<PutJobsJobIdPipelineCommentsCommentIdBody>},
        TContext
      > => {

      const mutationOptions = getPutJobsJobIdPipelineCommentsCommentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete a comment from a job's pipeline
 */
export const deleteJobsJobIdPipelineCommentsCommentId = (
    jobId: string,
    commentId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<DeleteJobsJobIdPipelineCommentsCommentId200>(
      {url: `/jobs/${jobId}/pipeline/comments/${commentId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteJobsJobIdPipelineCommentsCommentIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJobsJobIdPipelineCommentsCommentId>>, TError,{jobId: string;commentId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteJobsJobIdPipelineCommentsCommentId>>, TError,{jobId: string;commentId: string}, TContext> => {

const mutationKey = ['deleteJobsJobIdPipelineCommentsCommentId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJobsJobIdPipelineCommentsCommentId>>, {jobId: string;commentId: string}> = (props) => {
          const {jobId,commentId} = props ?? {};

          return  deleteJobsJobIdPipelineCommentsCommentId(jobId,commentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteJobsJobIdPipelineCommentsCommentIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteJobsJobIdPipelineCommentsCommentId>>>
    
    export type DeleteJobsJobIdPipelineCommentsCommentIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete a comment from a job's pipeline
 */
export const useDeleteJobsJobIdPipelineCommentsCommentId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJobsJobIdPipelineCommentsCommentId>>, TError,{jobId: string;commentId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteJobsJobIdPipelineCommentsCommentId>>,
        TError,
        {jobId: string;commentId: string},
        TContext
      > => {

      const mutationOptions = getDeleteJobsJobIdPipelineCommentsCommentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Soonest due first. Scoped to the caller's organization. Tasks are created, edited and deleted through /tasks.

 * @summary List every task on a job — on the job itself and on its candidates
 */
export const getJobsJobIdPipelineTasks = (
    jobId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<JobTask[]>(
      {url: `/jobs/${jobId}/pipeline/tasks`, method: 'GET', signal
    },
      options);
    }
  



export const getGetJobsJobIdPipelineTasksQueryKey = (jobId?: string,) => {
    return [
    `/jobs/${jobId}/pipeline/tasks`
    ] as const;
    }

    
export const getGetJobsJobIdPipelineTasksQueryOptions = <TData = Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>, TError = ErrorType<void>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsJobIdPipelineTasksQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>> = ({ signal }) => getJobsJobIdPipelineTasks(jobId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobsJobIdPipelineTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>>
export type GetJobsJobIdPipelineTasksQueryError = ErrorType<void>


export function useGetJobsJobIdPipelineTasks<TData = Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>, TError = ErrorType<void>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobIdPipelineTasks<TData = Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>, TError = ErrorType<void>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobIdPipelineTasks<TData = Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>, TError = ErrorType<void>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List every task on a job — on the job itself and on its candidates
 */

export function useGetJobsJobIdPipelineTasks<TData = Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>, TError = ErrorType<void>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdPipelineTasks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobsJobIdPipelineTasksQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get candidate profile connected to a job
 */
export const getJobsJobIdCandidate = (
    jobId: string,
    params?: GetJobsJobIdCandidateParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetJobsJobIdCandidate200>(
      {url: `/jobs/${jobId}/candidate`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetJobsJobIdCandidateQueryKey = (jobId?: string,
    params?: GetJobsJobIdCandidateParams,) => {
    return [
    `/jobs/${jobId}/candidate`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetJobsJobIdCandidateQueryOptions = <TData = Awaited<ReturnType<typeof getJobsJobIdCandidate>>, TError = ErrorType<unknown>>(jobId: string,
    params?: GetJobsJobIdCandidateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdCandidate>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsJobIdCandidateQueryKey(jobId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdCandidate>>> = ({ signal }) => getJobsJobIdCandidate(jobId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdCandidate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobsJobIdCandidateQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsJobIdCandidate>>>
export type GetJobsJobIdCandidateQueryError = ErrorType<unknown>


export function useGetJobsJobIdCandidate<TData = Awaited<ReturnType<typeof getJobsJobIdCandidate>>, TError = ErrorType<unknown>>(
 jobId: string,
    params: undefined |  GetJobsJobIdCandidateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdCandidate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobIdCandidate>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobIdCandidate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobIdCandidate<TData = Awaited<ReturnType<typeof getJobsJobIdCandidate>>, TError = ErrorType<unknown>>(
 jobId: string,
    params?: GetJobsJobIdCandidateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdCandidate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobIdCandidate>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobIdCandidate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobIdCandidate<TData = Awaited<ReturnType<typeof getJobsJobIdCandidate>>, TError = ErrorType<unknown>>(
 jobId: string,
    params?: GetJobsJobIdCandidateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdCandidate>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get candidate profile connected to a job
 */

export function useGetJobsJobIdCandidate<TData = Awaited<ReturnType<typeof getJobsJobIdCandidate>>, TError = ErrorType<unknown>>(
 jobId: string,
    params?: GetJobsJobIdCandidateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdCandidate>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobsJobIdCandidateQueryOptions(jobId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Upload a file for a job candidate
 */
export const postJobsPipelineJobCandidateIdFiles = (
    jobCandidateId: string,
    postJobsPipelineJobCandidateIdFilesBody: BodyType<PostJobsPipelineJobCandidateIdFilesBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(postJobsPipelineJobCandidateIdFilesBody.file !== undefined) {
 formData.append(`file`, postJobsPipelineJobCandidateIdFilesBody.file)
 }

      return customClient<PostJobsPipelineJobCandidateIdFiles200>(
      {url: `/jobs/pipeline/${jobCandidateId}/files`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getPostJobsPipelineJobCandidateIdFilesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postJobsPipelineJobCandidateIdFiles>>, TError,{jobCandidateId: string;data: BodyType<PostJobsPipelineJobCandidateIdFilesBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postJobsPipelineJobCandidateIdFiles>>, TError,{jobCandidateId: string;data: BodyType<PostJobsPipelineJobCandidateIdFilesBody>}, TContext> => {

const mutationKey = ['postJobsPipelineJobCandidateIdFiles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postJobsPipelineJobCandidateIdFiles>>, {jobCandidateId: string;data: BodyType<PostJobsPipelineJobCandidateIdFilesBody>}> = (props) => {
          const {jobCandidateId,data} = props ?? {};

          return  postJobsPipelineJobCandidateIdFiles(jobCandidateId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostJobsPipelineJobCandidateIdFilesMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsPipelineJobCandidateIdFiles>>>
    export type PostJobsPipelineJobCandidateIdFilesMutationBody = BodyType<PostJobsPipelineJobCandidateIdFilesBody>
    export type PostJobsPipelineJobCandidateIdFilesMutationError = ErrorType<unknown>

    /**
 * @summary Upload a file for a job candidate
 */
export const usePostJobsPipelineJobCandidateIdFiles = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postJobsPipelineJobCandidateIdFiles>>, TError,{jobCandidateId: string;data: BodyType<PostJobsPipelineJobCandidateIdFilesBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postJobsPipelineJobCandidateIdFiles>>,
        TError,
        {jobCandidateId: string;data: BodyType<PostJobsPipelineJobCandidateIdFilesBody>},
        TContext
      > => {

      const mutationOptions = getPostJobsPipelineJobCandidateIdFilesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetches all hiring manager records associated with a specific job,
including related contact information.

 * @summary Retrieve the hiring manager details for a specific job
 */
export const getJobsJobIdHiringManagers = (
    jobId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetJobsJobIdHiringManagers200Item[]>(
      {url: `/jobs/${jobId}/hiring-managers`, method: 'GET', signal
    },
      options);
    }
  



export const getGetJobsJobIdHiringManagersQueryKey = (jobId?: string,) => {
    return [
    `/jobs/${jobId}/hiring-managers`
    ] as const;
    }

    
export const getGetJobsJobIdHiringManagersQueryOptions = <TData = Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>, TError = ErrorType<void>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsJobIdHiringManagersQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>> = ({ signal }) => getJobsJobIdHiringManagers(jobId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobsJobIdHiringManagersQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>>
export type GetJobsJobIdHiringManagersQueryError = ErrorType<void>


export function useGetJobsJobIdHiringManagers<TData = Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>, TError = ErrorType<void>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobIdHiringManagers<TData = Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>, TError = ErrorType<void>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobIdHiringManagers<TData = Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>, TError = ErrorType<void>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the hiring manager details for a specific job
 */

export function useGetJobsJobIdHiringManagers<TData = Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>, TError = ErrorType<void>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdHiringManagers>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobsJobIdHiringManagersQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Atomically associates a job to an existing search query by setting `associated_search_id`,
but **only** if the job currently:
- Belongs to the authenticated user's organization.
- Has no existing association (`associated_search_id IS NULL`).

If the job is already associated, belongs to another organization, or does not exist,
no update is performed and a 409 response is returned.

 * @summary Associate a job with a search query
 */
export const patchJobsJobIdAssociateSearch = (
    jobId: string,
    patchJobsJobIdAssociateSearchBody: BodyType<PatchJobsJobIdAssociateSearchBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<PatchJobsJobIdAssociateSearch200>(
      {url: `/jobs/${jobId}/associate-search`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchJobsJobIdAssociateSearchBody
    },
      options);
    }
  


export const getPatchJobsJobIdAssociateSearchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchJobsJobIdAssociateSearch>>, TError,{jobId: string;data: BodyType<PatchJobsJobIdAssociateSearchBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchJobsJobIdAssociateSearch>>, TError,{jobId: string;data: BodyType<PatchJobsJobIdAssociateSearchBody>}, TContext> => {

const mutationKey = ['patchJobsJobIdAssociateSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchJobsJobIdAssociateSearch>>, {jobId: string;data: BodyType<PatchJobsJobIdAssociateSearchBody>}> = (props) => {
          const {jobId,data} = props ?? {};

          return  patchJobsJobIdAssociateSearch(jobId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchJobsJobIdAssociateSearchMutationResult = NonNullable<Awaited<ReturnType<typeof patchJobsJobIdAssociateSearch>>>
    export type PatchJobsJobIdAssociateSearchMutationBody = BodyType<PatchJobsJobIdAssociateSearchBody>
    export type PatchJobsJobIdAssociateSearchMutationError = ErrorType<unknown>

    /**
 * @summary Associate a job with a search query
 */
export const usePatchJobsJobIdAssociateSearch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchJobsJobIdAssociateSearch>>, TError,{jobId: string;data: BodyType<PatchJobsJobIdAssociateSearchBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchJobsJobIdAssociateSearch>>,
        TError,
        {jobId: string;data: BodyType<PatchJobsJobIdAssociateSearchBody>},
        TContext
      > => {

      const mutationOptions = getPatchJobsJobIdAssociateSearchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns a chronological feed of all job-related activities (candidates added, comments, tasks, emails, and calendar events) scoped automatically by the authenticated user's organization.

 * @summary Fetch all activity events related to a job
 */
export const getJobsJobIdActivities = (
    jobId: string,
    params?: GetJobsJobIdActivitiesParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<JobActivity[]>(
      {url: `/jobs/${jobId}/activities`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetJobsJobIdActivitiesQueryKey = (jobId?: string,
    params?: GetJobsJobIdActivitiesParams,) => {
    return [
    `/jobs/${jobId}/activities`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetJobsJobIdActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getJobsJobIdActivities>>, TError = ErrorType<void>>(jobId: string,
    params?: GetJobsJobIdActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdActivities>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobsJobIdActivitiesQueryKey(jobId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdActivities>>> = ({ signal }) => getJobsJobIdActivities(jobId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobsJobIdActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsJobIdActivities>>>
export type GetJobsJobIdActivitiesQueryError = ErrorType<void>


export function useGetJobsJobIdActivities<TData = Awaited<ReturnType<typeof getJobsJobIdActivities>>, TError = ErrorType<void>>(
 jobId: string,
    params: undefined |  GetJobsJobIdActivitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobIdActivities>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobIdActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobIdActivities<TData = Awaited<ReturnType<typeof getJobsJobIdActivities>>, TError = ErrorType<void>>(
 jobId: string,
    params?: GetJobsJobIdActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobsJobIdActivities>>,
          TError,
          Awaited<ReturnType<typeof getJobsJobIdActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobsJobIdActivities<TData = Awaited<ReturnType<typeof getJobsJobIdActivities>>, TError = ErrorType<void>>(
 jobId: string,
    params?: GetJobsJobIdActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdActivities>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch all activity events related to a job
 */

export function useGetJobsJobIdActivities<TData = Awaited<ReturnType<typeof getJobsJobIdActivities>>, TError = ErrorType<void>>(
 jobId: string,
    params?: GetJobsJobIdActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdActivities>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobsJobIdActivitiesQueryOptions(jobId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns a list of jobs with calculated risk and activity indicators.
Each record represents a job and includes details about its status,
recruiter, company, candidate counts, and overall health status.

 * @summary Retrieve job risk metrics for the organization
 */
export const getOrgObsJobRisks = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<JobRisk[]>(
      {url: `/orgObs/job-risks`, method: 'GET', signal
    },
      options);
    }
  



export const getGetOrgObsJobRisksQueryKey = () => {
    return [
    `/orgObs/job-risks`
    ] as const;
    }

    
export const getGetOrgObsJobRisksQueryOptions = <TData = Awaited<ReturnType<typeof getOrgObsJobRisks>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsJobRisks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgObsJobRisksQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgObsJobRisks>>> = ({ signal }) => getOrgObsJobRisks(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgObsJobRisks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgObsJobRisksQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgObsJobRisks>>>
export type GetOrgObsJobRisksQueryError = ErrorType<void>


export function useGetOrgObsJobRisks<TData = Awaited<ReturnType<typeof getOrgObsJobRisks>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsJobRisks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgObsJobRisks>>,
          TError,
          Awaited<ReturnType<typeof getOrgObsJobRisks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgObsJobRisks<TData = Awaited<ReturnType<typeof getOrgObsJobRisks>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsJobRisks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgObsJobRisks>>,
          TError,
          Awaited<ReturnType<typeof getOrgObsJobRisks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgObsJobRisks<TData = Awaited<ReturnType<typeof getOrgObsJobRisks>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsJobRisks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve job risk metrics for the organization
 */

export function useGetOrgObsJobRisks<TData = Awaited<ReturnType<typeof getOrgObsJobRisks>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsJobRisks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgObsJobRisksQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns all users and their roles for the current organization. Requires admin privileges.
 * @summary Get users of the current organization
 */
export const getOrgObsUsers = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetOrgObsUsers200Item[]>(
      {url: `/orgObs/users`, method: 'GET', signal
    },
      options);
    }
  



export const getGetOrgObsUsersQueryKey = () => {
    return [
    `/orgObs/users`
    ] as const;
    }

    
export const getGetOrgObsUsersQueryOptions = <TData = Awaited<ReturnType<typeof getOrgObsUsers>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsUsers>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgObsUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgObsUsers>>> = ({ signal }) => getOrgObsUsers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgObsUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgObsUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgObsUsers>>>
export type GetOrgObsUsersQueryError = ErrorType<void>


export function useGetOrgObsUsers<TData = Awaited<ReturnType<typeof getOrgObsUsers>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgObsUsers>>,
          TError,
          Awaited<ReturnType<typeof getOrgObsUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgObsUsers<TData = Awaited<ReturnType<typeof getOrgObsUsers>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgObsUsers>>,
          TError,
          Awaited<ReturnType<typeof getOrgObsUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgObsUsers<TData = Awaited<ReturnType<typeof getOrgObsUsers>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsUsers>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get users of the current organization
 */

export function useGetOrgObsUsers<TData = Awaited<ReturnType<typeof getOrgObsUsers>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsUsers>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgObsUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates the role of a user in the organization. Only admins can perform this action.
 * @summary Edit user role
 */
export const putOrgObsUsersRole = (
    putOrgObsUsersRoleBody: BodyType<PutOrgObsUsersRoleBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/orgObs/users/role`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putOrgObsUsersRoleBody
    },
      options);
    }
  


export const getPutOrgObsUsersRoleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrgObsUsersRole>>, TError,{data: BodyType<PutOrgObsUsersRoleBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putOrgObsUsersRole>>, TError,{data: BodyType<PutOrgObsUsersRoleBody>}, TContext> => {

const mutationKey = ['putOrgObsUsersRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putOrgObsUsersRole>>, {data: BodyType<PutOrgObsUsersRoleBody>}> = (props) => {
          const {data} = props ?? {};

          return  putOrgObsUsersRole(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutOrgObsUsersRoleMutationResult = NonNullable<Awaited<ReturnType<typeof putOrgObsUsersRole>>>
    export type PutOrgObsUsersRoleMutationBody = BodyType<PutOrgObsUsersRoleBody>
    export type PutOrgObsUsersRoleMutationError = ErrorType<void>

    /**
 * @summary Edit user role
 */
export const usePutOrgObsUsersRole = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrgObsUsersRole>>, TError,{data: BodyType<PutOrgObsUsersRoleBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putOrgObsUsersRole>>,
        TError,
        {data: BodyType<PutOrgObsUsersRoleBody>},
        TContext
      > => {

      const mutationOptions = getPutOrgObsUsersRoleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Removes a user's permission record, revoking access to the organization. Only admins can perform this action.
 * @summary Revoke user access
 */
export const deleteOrgObsUsersRevoke = (
    deleteOrgObsUsersRevokeBody: BodyType<DeleteOrgObsUsersRevokeBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/orgObs/users/revoke`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteOrgObsUsersRevokeBody
    },
      options);
    }
  


export const getDeleteOrgObsUsersRevokeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgObsUsersRevoke>>, TError,{data: BodyType<DeleteOrgObsUsersRevokeBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrgObsUsersRevoke>>, TError,{data: BodyType<DeleteOrgObsUsersRevokeBody>}, TContext> => {

const mutationKey = ['deleteOrgObsUsersRevoke'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrgObsUsersRevoke>>, {data: BodyType<DeleteOrgObsUsersRevokeBody>}> = (props) => {
          const {data} = props ?? {};

          return  deleteOrgObsUsersRevoke(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrgObsUsersRevokeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrgObsUsersRevoke>>>
    export type DeleteOrgObsUsersRevokeMutationBody = BodyType<DeleteOrgObsUsersRevokeBody>
    export type DeleteOrgObsUsersRevokeMutationError = ErrorType<void>

    /**
 * @summary Revoke user access
 */
export const useDeleteOrgObsUsersRevoke = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgObsUsersRevoke>>, TError,{data: BodyType<DeleteOrgObsUsersRevokeBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrgObsUsersRevoke>>,
        TError,
        {data: BodyType<DeleteOrgObsUsersRevokeBody>},
        TContext
      > => {

      const mutationOptions = getDeleteOrgObsUsersRevokeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves a list of organizations that the authenticated user has access to, based on their permissions.
 * @summary Get organizations for the authenticated user
 */
export const getOrgObsList = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetOrgObsList200Item[]>(
      {url: `/orgObs/list`, method: 'GET', signal
    },
      options);
    }
  



export const getGetOrgObsListQueryKey = () => {
    return [
    `/orgObs/list`
    ] as const;
    }

    
export const getGetOrgObsListQueryOptions = <TData = Awaited<ReturnType<typeof getOrgObsList>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsList>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgObsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgObsList>>> = ({ signal }) => getOrgObsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgObsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgObsListQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgObsList>>>
export type GetOrgObsListQueryError = ErrorType<void>


export function useGetOrgObsList<TData = Awaited<ReturnType<typeof getOrgObsList>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgObsList>>,
          TError,
          Awaited<ReturnType<typeof getOrgObsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgObsList<TData = Awaited<ReturnType<typeof getOrgObsList>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgObsList>>,
          TError,
          Awaited<ReturnType<typeof getOrgObsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgObsList<TData = Awaited<ReturnType<typeof getOrgObsList>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsList>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get organizations for the authenticated user
 */

export function useGetOrgObsList<TData = Awaited<ReturnType<typeof getOrgObsList>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsList>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgObsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns revenue attribution rows derived from placements and placement_splits for the authenticated user's organization.
- If the caller is not an admin, results are restricted to the caller's own contributions.
- If the caller is an admin, they may:
  - omit user_id to get all contributors,
  - or pass user_id to filter to a specific member.
If start_date and end_date are omitted, results are returned for all time.
You may optionally filter by company_id.

 * @summary Get revenue attribution details
 */
export const getOrgObsRevenue = (
    params?: GetOrgObsRevenueParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<RevenueDetailsResponse>(
      {url: `/orgObs/revenue`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetOrgObsRevenueQueryKey = (params?: GetOrgObsRevenueParams,) => {
    return [
    `/orgObs/revenue`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetOrgObsRevenueQueryOptions = <TData = Awaited<ReturnType<typeof getOrgObsRevenue>>, TError = ErrorType<void>>(params?: GetOrgObsRevenueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsRevenue>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgObsRevenueQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgObsRevenue>>> = ({ signal }) => getOrgObsRevenue(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgObsRevenue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgObsRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgObsRevenue>>>
export type GetOrgObsRevenueQueryError = ErrorType<void>


export function useGetOrgObsRevenue<TData = Awaited<ReturnType<typeof getOrgObsRevenue>>, TError = ErrorType<void>>(
 params: undefined |  GetOrgObsRevenueParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsRevenue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgObsRevenue>>,
          TError,
          Awaited<ReturnType<typeof getOrgObsRevenue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgObsRevenue<TData = Awaited<ReturnType<typeof getOrgObsRevenue>>, TError = ErrorType<void>>(
 params?: GetOrgObsRevenueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsRevenue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgObsRevenue>>,
          TError,
          Awaited<ReturnType<typeof getOrgObsRevenue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgObsRevenue<TData = Awaited<ReturnType<typeof getOrgObsRevenue>>, TError = ErrorType<void>>(
 params?: GetOrgObsRevenueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsRevenue>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get revenue attribution details
 */

export function useGetOrgObsRevenue<TData = Awaited<ReturnType<typeof getOrgObsRevenue>>, TError = ErrorType<void>>(
 params?: GetOrgObsRevenueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgObsRevenue>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgObsRevenueQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Generates outreach copy from candidate/job context. Use `type=email` for an email draft or `type=linkedin` for a LinkedIn message.

 * @summary Generate outreach content
 */
export const getOutreach = (
    params: GetOutreachParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetOutreach200>(
      {url: `/outreach`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetOutreachQueryKey = (params?: GetOutreachParams,) => {
    return [
    `/outreach`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetOutreachQueryOptions = <TData = Awaited<ReturnType<typeof getOutreach>>, TError = ErrorType<void>>(params: GetOutreachParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreach>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOutreachQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOutreach>>> = ({ signal }) => getOutreach(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOutreach>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOutreachQueryResult = NonNullable<Awaited<ReturnType<typeof getOutreach>>>
export type GetOutreachQueryError = ErrorType<void>


export function useGetOutreach<TData = Awaited<ReturnType<typeof getOutreach>>, TError = ErrorType<void>>(
 params: GetOutreachParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreach>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutreach>>,
          TError,
          Awaited<ReturnType<typeof getOutreach>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutreach<TData = Awaited<ReturnType<typeof getOutreach>>, TError = ErrorType<void>>(
 params: GetOutreachParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreach>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutreach>>,
          TError,
          Awaited<ReturnType<typeof getOutreach>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutreach<TData = Awaited<ReturnType<typeof getOutreach>>, TError = ErrorType<void>>(
 params: GetOutreachParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreach>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Generate outreach content
 */

export function useGetOutreach<TData = Awaited<ReturnType<typeof getOutreach>>, TError = ErrorType<void>>(
 params: GetOutreachParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutreach>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOutreachQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a new placement tied to a job_candidate, including revenue splits.
The authenticated user's organization_id and id are used as organization_id and created_by.
Only job_candidate records belonging to the same organization can be used.

 * @summary Create a placement
 */
export const postPlacements = (
    placementRequest: BodyType<PlacementRequest>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PlacementResponse>(
      {url: `/placements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: placementRequest, signal
    },
      options);
    }
  


export const getPostPlacementsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlacements>>, TError,{data: BodyType<PlacementRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postPlacements>>, TError,{data: BodyType<PlacementRequest>}, TContext> => {

const mutationKey = ['postPlacements'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPlacements>>, {data: BodyType<PlacementRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postPlacements(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPlacementsMutationResult = NonNullable<Awaited<ReturnType<typeof postPlacements>>>
    export type PostPlacementsMutationBody = BodyType<PlacementRequest>
    export type PostPlacementsMutationError = ErrorType<void>

    /**
 * @summary Create a placement
 */
export const usePostPlacements = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlacements>>, TError,{data: BodyType<PlacementRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPlacements>>,
        TError,
        {data: BodyType<PlacementRequest>},
        TContext
      > => {

      const mutationOptions = getPostPlacementsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns all placements for the authenticated user's organization.
If the user is not an admin (isAdmin = false), results are restricted to placements they created (created_by = user.id).
You can optionally filter by job_candidate_id.

 * @summary List placements
 */
export const getPlacements = (
    params?: GetPlacementsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PlacementListResponse>(
      {url: `/placements`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPlacementsQueryKey = (params?: GetPlacementsParams,) => {
    return [
    `/placements`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPlacementsQueryOptions = <TData = Awaited<ReturnType<typeof getPlacements>>, TError = ErrorType<void>>(params?: GetPlacementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlacements>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlacementsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlacements>>> = ({ signal }) => getPlacements(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlacements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlacementsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlacements>>>
export type GetPlacementsQueryError = ErrorType<void>


export function useGetPlacements<TData = Awaited<ReturnType<typeof getPlacements>>, TError = ErrorType<void>>(
 params: undefined |  GetPlacementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlacements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlacements>>,
          TError,
          Awaited<ReturnType<typeof getPlacements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlacements<TData = Awaited<ReturnType<typeof getPlacements>>, TError = ErrorType<void>>(
 params?: GetPlacementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlacements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlacements>>,
          TError,
          Awaited<ReturnType<typeof getPlacements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlacements<TData = Awaited<ReturnType<typeof getPlacements>>, TError = ErrorType<void>>(
 params?: GetPlacementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlacements>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List placements
 */

export function useGetPlacements<TData = Awaited<ReturnType<typeof getPlacements>>, TError = ErrorType<void>>(
 params?: GetPlacementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlacements>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlacementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves a single placement and its splits.
If the user is not an admin (isAdmin = false), the placement must have been created by this user.

 * @summary Get a placement by id
 */
export const getPlacementsId = (
    id: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PlacementResponse>(
      {url: `/placements/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPlacementsIdQueryKey = (id?: string,) => {
    return [
    `/placements/${id}`
    ] as const;
    }

    
export const getGetPlacementsIdQueryOptions = <TData = Awaited<ReturnType<typeof getPlacementsId>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlacementsId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlacementsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlacementsId>>> = ({ signal }) => getPlacementsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlacementsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlacementsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPlacementsId>>>
export type GetPlacementsIdQueryError = ErrorType<void>


export function useGetPlacementsId<TData = Awaited<ReturnType<typeof getPlacementsId>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlacementsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlacementsId>>,
          TError,
          Awaited<ReturnType<typeof getPlacementsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlacementsId<TData = Awaited<ReturnType<typeof getPlacementsId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlacementsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlacementsId>>,
          TError,
          Awaited<ReturnType<typeof getPlacementsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlacementsId<TData = Awaited<ReturnType<typeof getPlacementsId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlacementsId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a placement by id
 */

export function useGetPlacementsId<TData = Awaited<ReturnType<typeof getPlacementsId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlacementsId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlacementsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates a placement and completely replaces its revenue splits.
Splits must still sum to 100 percent.
The job_candidate used must belong to the same organization as the authenticated user.

 * @summary Update a placement
 */
export const putPlacementsId = (
    id: string,
    placementRequest: BodyType<PlacementRequest>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<PlacementResponse>(
      {url: `/placements/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: placementRequest
    },
      options);
    }
  


export const getPutPlacementsIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPlacementsId>>, TError,{id: string;data: BodyType<PlacementRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putPlacementsId>>, TError,{id: string;data: BodyType<PlacementRequest>}, TContext> => {

const mutationKey = ['putPlacementsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPlacementsId>>, {id: string;data: BodyType<PlacementRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  putPlacementsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPlacementsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPlacementsId>>>
    export type PutPlacementsIdMutationBody = BodyType<PlacementRequest>
    export type PutPlacementsIdMutationError = ErrorType<void>

    /**
 * @summary Update a placement
 */
export const usePutPlacementsId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPlacementsId>>, TError,{id: string;data: BodyType<PlacementRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPlacementsId>>,
        TError,
        {id: string;data: BodyType<PlacementRequest>},
        TContext
      > => {

      const mutationOptions = getPutPlacementsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Deletes a placement by id for the authenticated user's organization.
Associated placement_splits are removed via ON DELETE CASCADE.

 * @summary Delete a placement
 */
export const deletePlacementsId = (
    id: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/placements/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeletePlacementsIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlacementsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePlacementsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePlacementsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlacementsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePlacementsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePlacementsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlacementsId>>>
    
    export type DeletePlacementsIdMutationError = ErrorType<void>

    /**
 * @summary Delete a placement
 */
export const useDeletePlacementsId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlacementsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePlacementsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeletePlacementsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Initiates a search and returns a list of candidate profiles.
 * @summary Start a candidate search
 */
export const postSearchStart = (
    beginSearchRequest: BodyType<BeginSearchRequest>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<CandidateProfileResponse>(
      {url: `/search/start`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: beginSearchRequest, signal
    },
      options);
    }
  


export const getPostSearchStartMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSearchStart>>, TError,{data: BodyType<BeginSearchRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postSearchStart>>, TError,{data: BodyType<BeginSearchRequest>}, TContext> => {

const mutationKey = ['postSearchStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSearchStart>>, {data: BodyType<BeginSearchRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postSearchStart(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSearchStartMutationResult = NonNullable<Awaited<ReturnType<typeof postSearchStart>>>
    export type PostSearchStartMutationBody = BodyType<BeginSearchRequest>
    export type PostSearchStartMutationError = ErrorType<unknown>

    /**
 * @summary Start a candidate search
 */
export const usePostSearchStart = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSearchStart>>, TError,{data: BodyType<BeginSearchRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSearchStart>>,
        TError,
        {data: BodyType<BeginSearchRequest>},
        TContext
      > => {

      const mutationOptions = getPostSearchStartMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the total number of candidates that would match the given search query, without returning candidate records.
 * @summary Get candidate results count
 */
export const postSearchCount = (
    beginSearchRequest: BodyType<BeginSearchRequest>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<PostSearchCount200>(
      {url: `/search/count`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: beginSearchRequest, signal
    },
      options);
    }
  


export const getPostSearchCountMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSearchCount>>, TError,{data: BodyType<BeginSearchRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postSearchCount>>, TError,{data: BodyType<BeginSearchRequest>}, TContext> => {

const mutationKey = ['postSearchCount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSearchCount>>, {data: BodyType<BeginSearchRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postSearchCount(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSearchCountMutationResult = NonNullable<Awaited<ReturnType<typeof postSearchCount>>>
    export type PostSearchCountMutationBody = BodyType<BeginSearchRequest>
    export type PostSearchCountMutationError = ErrorType<void>

    /**
 * @summary Get candidate results count
 */
export const usePostSearchCount = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSearchCount>>, TError,{data: BodyType<BeginSearchRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSearchCount>>,
        TError,
        {data: BodyType<BeginSearchRequest>},
        TContext
      > => {

      const mutationOptions = getPostSearchCountMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Enriches a cached candidate profile by reusing an existing search query (identified by its normalized hash) to derive role, seniority, skills, and company context. The enrichment is scoped to the caller's organization.

 * @summary Enrich an individual candidate profile using stored search context
 */
export const getSearchEnrichProfilesCandidateId = (
    candidateId: string,
    params: GetSearchEnrichProfilesCandidateIdParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetSearchEnrichProfilesCandidateId200>(
      {url: `/search/enrich-profiles/${candidateId}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetSearchEnrichProfilesCandidateIdQueryKey = (candidateId?: string,
    params?: GetSearchEnrichProfilesCandidateIdParams,) => {
    return [
    `/search/enrich-profiles/${candidateId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSearchEnrichProfilesCandidateIdQueryOptions = <TData = Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>, TError = ErrorType<void>>(candidateId: string,
    params: GetSearchEnrichProfilesCandidateIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchEnrichProfilesCandidateIdQueryKey(candidateId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>> = ({ signal }) => getSearchEnrichProfilesCandidateId(candidateId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(candidateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchEnrichProfilesCandidateIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>>
export type GetSearchEnrichProfilesCandidateIdQueryError = ErrorType<void>


export function useGetSearchEnrichProfilesCandidateId<TData = Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>, TError = ErrorType<void>>(
 candidateId: string,
    params: GetSearchEnrichProfilesCandidateIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>,
          TError,
          Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchEnrichProfilesCandidateId<TData = Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>, TError = ErrorType<void>>(
 candidateId: string,
    params: GetSearchEnrichProfilesCandidateIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>,
          TError,
          Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchEnrichProfilesCandidateId<TData = Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>, TError = ErrorType<void>>(
 candidateId: string,
    params: GetSearchEnrichProfilesCandidateIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Enrich an individual candidate profile using stored search context
 */

export function useGetSearchEnrichProfilesCandidateId<TData = Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>, TError = ErrorType<void>>(
 candidateId: string,
    params: GetSearchEnrichProfilesCandidateIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchEnrichProfilesCandidateId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchEnrichProfilesCandidateIdQueryOptions(candidateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Initiates a search and returns a list of candidate profiles.
 * @summary Start a candidate search
 */
export const putSearchSearchId = (
    searchId: string,
    beginSearchRequest: BodyType<BeginSearchRequest>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<CandidateProfileResponse>(
      {url: `/search/${searchId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: beginSearchRequest
    },
      options);
    }
  


export const getPutSearchSearchIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSearchSearchId>>, TError,{searchId: string;data: BodyType<BeginSearchRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putSearchSearchId>>, TError,{searchId: string;data: BodyType<BeginSearchRequest>}, TContext> => {

const mutationKey = ['putSearchSearchId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSearchSearchId>>, {searchId: string;data: BodyType<BeginSearchRequest>}> = (props) => {
          const {searchId,data} = props ?? {};

          return  putSearchSearchId(searchId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutSearchSearchIdMutationResult = NonNullable<Awaited<ReturnType<typeof putSearchSearchId>>>
    export type PutSearchSearchIdMutationBody = BodyType<BeginSearchRequest>
    export type PutSearchSearchIdMutationError = ErrorType<unknown>

    /**
 * @summary Start a candidate search
 */
export const usePutSearchSearchId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSearchSearchId>>, TError,{searchId: string;data: BodyType<BeginSearchRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSearchSearchId>>,
        TError,
        {searchId: string;data: BodyType<BeginSearchRequest>},
        TContext
      > => {

      const mutationOptions = getPutSearchSearchIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get enriched candidates and talent intelligence by search hash
 */
export const getSearchResultsHash = (
    hash: string,
    params?: GetSearchResultsHashParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetSearchResultsHash200>(
      {url: `/search/results/${hash}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetSearchResultsHashQueryKey = (hash?: string,
    params?: GetSearchResultsHashParams,) => {
    return [
    `/search/results/${hash}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSearchResultsHashQueryOptions = <TData = Awaited<ReturnType<typeof getSearchResultsHash>>, TError = ErrorType<unknown>>(hash: string,
    params?: GetSearchResultsHashParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResultsHash>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchResultsHashQueryKey(hash,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchResultsHash>>> = ({ signal }) => getSearchResultsHash(hash,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(hash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSearchResultsHash>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchResultsHashQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchResultsHash>>>
export type GetSearchResultsHashQueryError = ErrorType<unknown>


export function useGetSearchResultsHash<TData = Awaited<ReturnType<typeof getSearchResultsHash>>, TError = ErrorType<unknown>>(
 hash: string,
    params: undefined |  GetSearchResultsHashParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResultsHash>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchResultsHash>>,
          TError,
          Awaited<ReturnType<typeof getSearchResultsHash>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchResultsHash<TData = Awaited<ReturnType<typeof getSearchResultsHash>>, TError = ErrorType<unknown>>(
 hash: string,
    params?: GetSearchResultsHashParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResultsHash>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchResultsHash>>,
          TError,
          Awaited<ReturnType<typeof getSearchResultsHash>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchResultsHash<TData = Awaited<ReturnType<typeof getSearchResultsHash>>, TError = ErrorType<unknown>>(
 hash: string,
    params?: GetSearchResultsHashParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResultsHash>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get enriched candidates and talent intelligence by search hash
 */

export function useGetSearchResultsHash<TData = Awaited<ReturnType<typeof getSearchResultsHash>>, TError = ErrorType<unknown>>(
 hash: string,
    params?: GetSearchResultsHashParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResultsHash>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchResultsHashQueryOptions(hash,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Hydrate cached search results for a requested page without returning profiles
 */
export const getSearchResultsHashProbe = (
    hash: string,
    params?: GetSearchResultsHashProbeParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetSearchResultsHashProbe200>(
      {url: `/search/results/${hash}/probe`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetSearchResultsHashProbeQueryKey = (hash?: string,
    params?: GetSearchResultsHashProbeParams,) => {
    return [
    `/search/results/${hash}/probe`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSearchResultsHashProbeQueryOptions = <TData = Awaited<ReturnType<typeof getSearchResultsHashProbe>>, TError = ErrorType<unknown>>(hash: string,
    params?: GetSearchResultsHashProbeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResultsHashProbe>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchResultsHashProbeQueryKey(hash,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchResultsHashProbe>>> = ({ signal }) => getSearchResultsHashProbe(hash,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(hash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSearchResultsHashProbe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchResultsHashProbeQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchResultsHashProbe>>>
export type GetSearchResultsHashProbeQueryError = ErrorType<unknown>


export function useGetSearchResultsHashProbe<TData = Awaited<ReturnType<typeof getSearchResultsHashProbe>>, TError = ErrorType<unknown>>(
 hash: string,
    params: undefined |  GetSearchResultsHashProbeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResultsHashProbe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchResultsHashProbe>>,
          TError,
          Awaited<ReturnType<typeof getSearchResultsHashProbe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchResultsHashProbe<TData = Awaited<ReturnType<typeof getSearchResultsHashProbe>>, TError = ErrorType<unknown>>(
 hash: string,
    params?: GetSearchResultsHashProbeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResultsHashProbe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchResultsHashProbe>>,
          TError,
          Awaited<ReturnType<typeof getSearchResultsHashProbe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchResultsHashProbe<TData = Awaited<ReturnType<typeof getSearchResultsHashProbe>>, TError = ErrorType<unknown>>(
 hash: string,
    params?: GetSearchResultsHashProbeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResultsHashProbe>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Hydrate cached search results for a requested page without returning profiles
 */

export function useGetSearchResultsHashProbe<TData = Awaited<ReturnType<typeof getSearchResultsHashProbe>>, TError = ErrorType<unknown>>(
 hash: string,
    params?: GetSearchResultsHashProbeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchResultsHashProbe>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchResultsHashProbeQueryOptions(hash,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Extract structured search filters from a natural language prompt
 */
export const postSearchFilters = (
    extractFiltersRequest: BodyType<ExtractFiltersRequest>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<ExtractFiltersResponse>(
      {url: `/search/filters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: extractFiltersRequest, signal
    },
      options);
    }
  


export const getPostSearchFiltersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSearchFilters>>, TError,{data: BodyType<ExtractFiltersRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postSearchFilters>>, TError,{data: BodyType<ExtractFiltersRequest>}, TContext> => {

const mutationKey = ['postSearchFilters'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSearchFilters>>, {data: BodyType<ExtractFiltersRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postSearchFilters(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSearchFiltersMutationResult = NonNullable<Awaited<ReturnType<typeof postSearchFilters>>>
    export type PostSearchFiltersMutationBody = BodyType<ExtractFiltersRequest>
    export type PostSearchFiltersMutationError = ErrorType<unknown>

    /**
 * @summary Extract structured search filters from a natural language prompt
 */
export const usePostSearchFilters = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSearchFilters>>, TError,{data: BodyType<ExtractFiltersRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSearchFilters>>,
        TError,
        {data: BodyType<ExtractFiltersRequest>},
        TContext
      > => {

      const mutationOptions = getPostSearchFiltersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get additional values for given filter values
 */
export const postSearchFiltersEnrich = (
    postSearchFiltersEnrichBody: BodyType<PostSearchFiltersEnrichBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<string[]>(
      {url: `/search/filters/enrich`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSearchFiltersEnrichBody, signal
    },
      options);
    }
  


export const getPostSearchFiltersEnrichMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSearchFiltersEnrich>>, TError,{data: BodyType<PostSearchFiltersEnrichBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postSearchFiltersEnrich>>, TError,{data: BodyType<PostSearchFiltersEnrichBody>}, TContext> => {

const mutationKey = ['postSearchFiltersEnrich'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSearchFiltersEnrich>>, {data: BodyType<PostSearchFiltersEnrichBody>}> = (props) => {
          const {data} = props ?? {};

          return  postSearchFiltersEnrich(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSearchFiltersEnrichMutationResult = NonNullable<Awaited<ReturnType<typeof postSearchFiltersEnrich>>>
    export type PostSearchFiltersEnrichMutationBody = BodyType<PostSearchFiltersEnrichBody>
    export type PostSearchFiltersEnrichMutationError = ErrorType<unknown>

    /**
 * @summary Get additional values for given filter values
 */
export const usePostSearchFiltersEnrich = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSearchFiltersEnrich>>, TError,{data: BodyType<PostSearchFiltersEnrichBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSearchFiltersEnrich>>,
        TError,
        {data: BodyType<PostSearchFiltersEnrichBody>},
        TContext
      > => {

      const mutationOptions = getPostSearchFiltersEnrichMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get Google-backed city autocomplete suggestions for search locations
 */
export const getSearchLocationAutocomplete = (
    params: GetSearchLocationAutocompleteParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetSearchLocationAutocomplete200>(
      {url: `/search/location-autocomplete`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetSearchLocationAutocompleteQueryKey = (params?: GetSearchLocationAutocompleteParams,) => {
    return [
    `/search/location-autocomplete`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSearchLocationAutocompleteQueryOptions = <TData = Awaited<ReturnType<typeof getSearchLocationAutocomplete>>, TError = ErrorType<void>>(params: GetSearchLocationAutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchLocationAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchLocationAutocompleteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchLocationAutocomplete>>> = ({ signal }) => getSearchLocationAutocomplete(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSearchLocationAutocomplete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchLocationAutocompleteQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchLocationAutocomplete>>>
export type GetSearchLocationAutocompleteQueryError = ErrorType<void>


export function useGetSearchLocationAutocomplete<TData = Awaited<ReturnType<typeof getSearchLocationAutocomplete>>, TError = ErrorType<void>>(
 params: GetSearchLocationAutocompleteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchLocationAutocomplete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchLocationAutocomplete>>,
          TError,
          Awaited<ReturnType<typeof getSearchLocationAutocomplete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchLocationAutocomplete<TData = Awaited<ReturnType<typeof getSearchLocationAutocomplete>>, TError = ErrorType<void>>(
 params: GetSearchLocationAutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchLocationAutocomplete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchLocationAutocomplete>>,
          TError,
          Awaited<ReturnType<typeof getSearchLocationAutocomplete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchLocationAutocomplete<TData = Awaited<ReturnType<typeof getSearchLocationAutocomplete>>, TError = ErrorType<void>>(
 params: GetSearchLocationAutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchLocationAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Google-backed city autocomplete suggestions for search locations
 */

export function useGetSearchLocationAutocomplete<TData = Awaited<ReturnType<typeof getSearchLocationAutocomplete>>, TError = ErrorType<void>>(
 params: GetSearchLocationAutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchLocationAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchLocationAutocompleteQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Resolve a selected location suggestion into canonical city, region, and country values
 */
export const getSearchLocationResolve = (
    params: GetSearchLocationResolveParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetSearchLocationResolve200>(
      {url: `/search/location-resolve`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetSearchLocationResolveQueryKey = (params?: GetSearchLocationResolveParams,) => {
    return [
    `/search/location-resolve`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSearchLocationResolveQueryOptions = <TData = Awaited<ReturnType<typeof getSearchLocationResolve>>, TError = ErrorType<void>>(params: GetSearchLocationResolveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchLocationResolve>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchLocationResolveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchLocationResolve>>> = ({ signal }) => getSearchLocationResolve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSearchLocationResolve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchLocationResolveQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchLocationResolve>>>
export type GetSearchLocationResolveQueryError = ErrorType<void>


export function useGetSearchLocationResolve<TData = Awaited<ReturnType<typeof getSearchLocationResolve>>, TError = ErrorType<void>>(
 params: GetSearchLocationResolveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchLocationResolve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchLocationResolve>>,
          TError,
          Awaited<ReturnType<typeof getSearchLocationResolve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchLocationResolve<TData = Awaited<ReturnType<typeof getSearchLocationResolve>>, TError = ErrorType<void>>(
 params: GetSearchLocationResolveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchLocationResolve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchLocationResolve>>,
          TError,
          Awaited<ReturnType<typeof getSearchLocationResolve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchLocationResolve<TData = Awaited<ReturnType<typeof getSearchLocationResolve>>, TError = ErrorType<void>>(
 params: GetSearchLocationResolveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchLocationResolve>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolve a selected location suggestion into canonical city, region, and country values
 */

export function useGetSearchLocationResolve<TData = Awaited<ReturnType<typeof getSearchLocationResolve>>, TError = ErrorType<void>>(
 params: GetSearchLocationResolveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchLocationResolve>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchLocationResolveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns a list of enriched candidate profiles and their AI evaluation context.
Each candidate contains one or more `profile` variants (from enrichment sources)
and a `talentIntelligence` object summarizing the AI-based match evaluation.

 * @summary Get search keywords by hash
 */
export const getSearchKeywordsHash = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetSearchKeywordsHash200>(
      {url: `/search/keywords/:hash`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSearchKeywordsHashQueryKey = () => {
    return [
    `/search/keywords/:hash`
    ] as const;
    }

    
export const getGetSearchKeywordsHashQueryOptions = <TData = Awaited<ReturnType<typeof getSearchKeywordsHash>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchKeywordsHash>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchKeywordsHashQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchKeywordsHash>>> = ({ signal }) => getSearchKeywordsHash(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSearchKeywordsHash>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchKeywordsHashQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchKeywordsHash>>>
export type GetSearchKeywordsHashQueryError = ErrorType<unknown>


export function useGetSearchKeywordsHash<TData = Awaited<ReturnType<typeof getSearchKeywordsHash>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchKeywordsHash>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchKeywordsHash>>,
          TError,
          Awaited<ReturnType<typeof getSearchKeywordsHash>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchKeywordsHash<TData = Awaited<ReturnType<typeof getSearchKeywordsHash>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchKeywordsHash>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchKeywordsHash>>,
          TError,
          Awaited<ReturnType<typeof getSearchKeywordsHash>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchKeywordsHash<TData = Awaited<ReturnType<typeof getSearchKeywordsHash>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchKeywordsHash>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get search keywords by hash
 */

export function useGetSearchKeywordsHash<TData = Awaited<ReturnType<typeof getSearchKeywordsHash>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchKeywordsHash>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchKeywordsHashQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the normalized search criteria for a given query hash. These parameters are used to retrieve matching candidates through the `/search/candidate/{hash}` endpoint.

 * @summary Retrieve search query parameters and matched criteria
 */
export const getSearchQueries = (
    params: GetSearchQueriesParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetSearchQueries200>(
      {url: `/search/queries`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetSearchQueriesQueryKey = (params?: GetSearchQueriesParams,) => {
    return [
    `/search/queries`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSearchQueriesQueryOptions = <TData = Awaited<ReturnType<typeof getSearchQueries>>, TError = ErrorType<unknown>>(params: GetSearchQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchQueries>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchQueriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchQueries>>> = ({ signal }) => getSearchQueries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSearchQueries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchQueriesQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchQueries>>>
export type GetSearchQueriesQueryError = ErrorType<unknown>


export function useGetSearchQueries<TData = Awaited<ReturnType<typeof getSearchQueries>>, TError = ErrorType<unknown>>(
 params: GetSearchQueriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchQueries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchQueries>>,
          TError,
          Awaited<ReturnType<typeof getSearchQueries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchQueries<TData = Awaited<ReturnType<typeof getSearchQueries>>, TError = ErrorType<unknown>>(
 params: GetSearchQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchQueries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchQueries>>,
          TError,
          Awaited<ReturnType<typeof getSearchQueries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchQueries<TData = Awaited<ReturnType<typeof getSearchQueries>>, TError = ErrorType<unknown>>(
 params: GetSearchQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchQueries>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve search query parameters and matched criteria
 */

export function useGetSearchQueries<TData = Awaited<ReturnType<typeof getSearchQueries>>, TError = ErrorType<unknown>>(
 params: GetSearchQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchQueries>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchQueriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns a list of saved search queries created by the authenticated user.
Each search query stores the normalized hash, parameters, and associated metadata
such as prompt, total result count, and organization context.

 * @summary Retrieve all searches
 */
export const getSearch = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetSearch200Item[]>(
      {url: `/search`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSearchQueryKey = () => {
    return [
    `/search`
    ] as const;
    }

    
export const getGetSearchQueryOptions = <TData = Awaited<ReturnType<typeof getSearch>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearch>>> = ({ signal }) => getSearch(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getSearch>>>
export type GetSearchQueryError = ErrorType<void>


export function useGetSearch<TData = Awaited<ReturnType<typeof getSearch>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearch>>,
          TError,
          Awaited<ReturnType<typeof getSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearch<TData = Awaited<ReturnType<typeof getSearch>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearch>>,
          TError,
          Awaited<ReturnType<typeof getSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearch<TData = Awaited<ReturnType<typeof getSearch>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve all searches
 */

export function useGetSearch<TData = Awaited<ReturnType<typeof getSearch>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List tasks (optional filter by entity_type, job_candidate_id & entity_id)
 */
export const getTasks = (
    params?: GetTasksParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Task[]>(
      {url: `/tasks`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetTasksQueryKey = (params?: GetTasksParams,) => {
    return [
    `/tasks`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTasksQueryOptions = <TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasks>>> = ({ signal }) => getTasks(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getTasks>>>
export type GetTasksQueryError = ErrorType<unknown>


export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
 params: undefined |  GetTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List tasks (optional filter by entity_type, job_candidate_id & entity_id)
 */

export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a new task
 */
export const postTasks = (
    postTasksBody: BodyType<PostTasksBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Task>(
      {url: `/tasks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postTasksBody, signal
    },
      options);
    }
  


export const getPostTasksMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTasks>>, TError,{data: BodyType<PostTasksBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postTasks>>, TError,{data: BodyType<PostTasksBody>}, TContext> => {

const mutationKey = ['postTasks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTasks>>, {data: BodyType<PostTasksBody>}> = (props) => {
          const {data} = props ?? {};

          return  postTasks(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTasksMutationResult = NonNullable<Awaited<ReturnType<typeof postTasks>>>
    export type PostTasksMutationBody = BodyType<PostTasksBody>
    export type PostTasksMutationError = ErrorType<unknown>

    /**
 * @summary Create a new task
 */
export const usePostTasks = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTasks>>, TError,{data: BodyType<PostTasksBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTasks>>,
        TError,
        {data: BodyType<PostTasksBody>},
        TContext
      > => {

      const mutationOptions = getPostTasksMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update a task
 */
export const putTasksTaskId = (
    taskId: string,
    putTasksTaskIdBody: BodyType<PutTasksTaskIdBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<Task>(
      {url: `/tasks/${taskId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putTasksTaskIdBody
    },
      options);
    }
  


export const getPutTasksTaskIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTasksTaskId>>, TError,{taskId: string;data: BodyType<PutTasksTaskIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putTasksTaskId>>, TError,{taskId: string;data: BodyType<PutTasksTaskIdBody>}, TContext> => {

const mutationKey = ['putTasksTaskId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTasksTaskId>>, {taskId: string;data: BodyType<PutTasksTaskIdBody>}> = (props) => {
          const {taskId,data} = props ?? {};

          return  putTasksTaskId(taskId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutTasksTaskIdMutationResult = NonNullable<Awaited<ReturnType<typeof putTasksTaskId>>>
    export type PutTasksTaskIdMutationBody = BodyType<PutTasksTaskIdBody>
    export type PutTasksTaskIdMutationError = ErrorType<unknown>

    /**
 * @summary Update a task
 */
export const usePutTasksTaskId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTasksTaskId>>, TError,{taskId: string;data: BodyType<PutTasksTaskIdBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTasksTaskId>>,
        TError,
        {taskId: string;data: BodyType<PutTasksTaskIdBody>},
        TContext
      > => {

      const mutationOptions = getPutTasksTaskIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete a task
 */
export const deleteTasksTaskId = (
    taskId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/tasks/${taskId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteTasksTaskIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTasksTaskId>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTasksTaskId>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['deleteTasksTaskId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTasksTaskId>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  deleteTasksTaskId(taskId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTasksTaskIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTasksTaskId>>>
    
    export type DeleteTasksTaskIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete a task
 */
export const useDeleteTasksTaskId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTasksTaskId>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTasksTaskId>>,
        TError,
        {taskId: string},
        TContext
      > => {

      const mutationOptions = getDeleteTasksTaskIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update task status
 */
export const patchTasksTaskIdStatus = (
    taskId: string,
    patchTasksTaskIdStatusBody: BodyType<PatchTasksTaskIdStatusBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<PatchTasksTaskIdStatus200>(
      {url: `/tasks/${taskId}/status`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchTasksTaskIdStatusBody
    },
      options);
    }
  


export const getPatchTasksTaskIdStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTasksTaskIdStatus>>, TError,{taskId: string;data: BodyType<PatchTasksTaskIdStatusBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchTasksTaskIdStatus>>, TError,{taskId: string;data: BodyType<PatchTasksTaskIdStatusBody>}, TContext> => {

const mutationKey = ['patchTasksTaskIdStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTasksTaskIdStatus>>, {taskId: string;data: BodyType<PatchTasksTaskIdStatusBody>}> = (props) => {
          const {taskId,data} = props ?? {};

          return  patchTasksTaskIdStatus(taskId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTasksTaskIdStatusMutationResult = NonNullable<Awaited<ReturnType<typeof patchTasksTaskIdStatus>>>
    export type PatchTasksTaskIdStatusMutationBody = BodyType<PatchTasksTaskIdStatusBody>
    export type PatchTasksTaskIdStatusMutationError = ErrorType<unknown>

    /**
 * @summary Update task status
 */
export const usePatchTasksTaskIdStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTasksTaskIdStatus>>, TError,{taskId: string;data: BodyType<PatchTasksTaskIdStatusBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchTasksTaskIdStatus>>,
        TError,
        {taskId: string;data: BodyType<PatchTasksTaskIdStatusBody>},
        TContext
      > => {

      const mutationOptions = getPatchTasksTaskIdStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Sends an email to the contact associated with a touchpoint and logs it atomically. Validates that the email provided matches the contact linked to the touchpoint and that the user owns the corresponding bucket.

 * @summary Approve and send a touchpoint email
 */
export const postTouchpointsTouchpointIdApprove = (
    touchpointId: string,
    postTouchpointsTouchpointIdApproveBody: BodyType<PostTouchpointsTouchpointIdApproveBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<void>(
      {url: `/touchpoints/${touchpointId}/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postTouchpointsTouchpointIdApproveBody, signal
    },
      options);
    }
  


export const getPostTouchpointsTouchpointIdApproveMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTouchpointsTouchpointIdApprove>>, TError,{touchpointId: string;data: BodyType<PostTouchpointsTouchpointIdApproveBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postTouchpointsTouchpointIdApprove>>, TError,{touchpointId: string;data: BodyType<PostTouchpointsTouchpointIdApproveBody>}, TContext> => {

const mutationKey = ['postTouchpointsTouchpointIdApprove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTouchpointsTouchpointIdApprove>>, {touchpointId: string;data: BodyType<PostTouchpointsTouchpointIdApproveBody>}> = (props) => {
          const {touchpointId,data} = props ?? {};

          return  postTouchpointsTouchpointIdApprove(touchpointId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTouchpointsTouchpointIdApproveMutationResult = NonNullable<Awaited<ReturnType<typeof postTouchpointsTouchpointIdApprove>>>
    export type PostTouchpointsTouchpointIdApproveMutationBody = BodyType<PostTouchpointsTouchpointIdApproveBody>
    export type PostTouchpointsTouchpointIdApproveMutationError = ErrorType<void>

    /**
 * @summary Approve and send a touchpoint email
 */
export const usePostTouchpointsTouchpointIdApprove = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTouchpointsTouchpointIdApprove>>, TError,{touchpointId: string;data: BodyType<PostTouchpointsTouchpointIdApproveBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTouchpointsTouchpointIdApprove>>,
        TError,
        {touchpointId: string;data: BodyType<PostTouchpointsTouchpointIdApproveBody>},
        TContext
      > => {

      const mutationOptions = getPostTouchpointsTouchpointIdApproveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns all touchpoints that are due (scheduled_for <= now) and have not yet been sent or approved. Data is pulled from the `view_touchpoints_detailed` view, which includes contact, bucket, and AI context information.

 * @summary Get all due and unsent touchpoints
 */
export const getTouchpointsDue = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetTouchpointsDue200Item[]>(
      {url: `/touchpoints/due`, method: 'GET', signal
    },
      options);
    }
  



export const getGetTouchpointsDueQueryKey = () => {
    return [
    `/touchpoints/due`
    ] as const;
    }

    
export const getGetTouchpointsDueQueryOptions = <TData = Awaited<ReturnType<typeof getTouchpointsDue>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTouchpointsDue>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTouchpointsDueQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTouchpointsDue>>> = ({ signal }) => getTouchpointsDue(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTouchpointsDue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTouchpointsDueQueryResult = NonNullable<Awaited<ReturnType<typeof getTouchpointsDue>>>
export type GetTouchpointsDueQueryError = ErrorType<void>


export function useGetTouchpointsDue<TData = Awaited<ReturnType<typeof getTouchpointsDue>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTouchpointsDue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTouchpointsDue>>,
          TError,
          Awaited<ReturnType<typeof getTouchpointsDue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTouchpointsDue<TData = Awaited<ReturnType<typeof getTouchpointsDue>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTouchpointsDue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTouchpointsDue>>,
          TError,
          Awaited<ReturnType<typeof getTouchpointsDue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTouchpointsDue<TData = Awaited<ReturnType<typeof getTouchpointsDue>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTouchpointsDue>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all due and unsent touchpoints
 */

export function useGetTouchpointsDue<TData = Awaited<ReturnType<typeof getTouchpointsDue>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTouchpointsDue>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTouchpointsDueQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List email signatures for the current user
 */
export const getSignature = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<EmailSignature[]>(
      {url: `/signature`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSignatureQueryKey = () => {
    return [
    `/signature`
    ] as const;
    }

    
export const getGetSignatureQueryOptions = <TData = Awaited<ReturnType<typeof getSignature>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignature>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSignatureQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSignature>>> = ({ signal }) => getSignature(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSignature>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSignatureQueryResult = NonNullable<Awaited<ReturnType<typeof getSignature>>>
export type GetSignatureQueryError = ErrorType<unknown>


export function useGetSignature<TData = Awaited<ReturnType<typeof getSignature>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignature>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSignature>>,
          TError,
          Awaited<ReturnType<typeof getSignature>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSignature<TData = Awaited<ReturnType<typeof getSignature>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignature>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSignature>>,
          TError,
          Awaited<ReturnType<typeof getSignature>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSignature<TData = Awaited<ReturnType<typeof getSignature>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignature>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List email signatures for the current user
 */

export function useGetSignature<TData = Awaited<ReturnType<typeof getSignature>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignature>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSignatureQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a new email signature
 */
export const postSignature = (
    createEmailSignatureRequest: BodyType<CreateEmailSignatureRequest>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<EmailSignature>(
      {url: `/signature`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEmailSignatureRequest, signal
    },
      options);
    }
  


export const getPostSignatureMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSignature>>, TError,{data: BodyType<CreateEmailSignatureRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postSignature>>, TError,{data: BodyType<CreateEmailSignatureRequest>}, TContext> => {

const mutationKey = ['postSignature'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSignature>>, {data: BodyType<CreateEmailSignatureRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postSignature(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof postSignature>>>
    export type PostSignatureMutationBody = BodyType<CreateEmailSignatureRequest>
    export type PostSignatureMutationError = ErrorType<unknown>

    /**
 * @summary Create a new email signature
 */
export const usePostSignature = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSignature>>, TError,{data: BodyType<CreateEmailSignatureRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSignature>>,
        TError,
        {data: BodyType<CreateEmailSignatureRequest>},
        TContext
      > => {

      const mutationOptions = getPostSignatureMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update an existing email signature
 */
export const putSignatureSignatureId = (
    signatureId: string,
    updateEmailSignatureRequest: BodyType<UpdateEmailSignatureRequest>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<EmailSignature>(
      {url: `/signature/${signatureId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateEmailSignatureRequest
    },
      options);
    }
  


export const getPutSignatureSignatureIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignatureSignatureId>>, TError,{signatureId: string;data: BodyType<UpdateEmailSignatureRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putSignatureSignatureId>>, TError,{signatureId: string;data: BodyType<UpdateEmailSignatureRequest>}, TContext> => {

const mutationKey = ['putSignatureSignatureId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSignatureSignatureId>>, {signatureId: string;data: BodyType<UpdateEmailSignatureRequest>}> = (props) => {
          const {signatureId,data} = props ?? {};

          return  putSignatureSignatureId(signatureId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutSignatureSignatureIdMutationResult = NonNullable<Awaited<ReturnType<typeof putSignatureSignatureId>>>
    export type PutSignatureSignatureIdMutationBody = BodyType<UpdateEmailSignatureRequest>
    export type PutSignatureSignatureIdMutationError = ErrorType<unknown>

    /**
 * @summary Update an existing email signature
 */
export const usePutSignatureSignatureId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignatureSignatureId>>, TError,{signatureId: string;data: BodyType<UpdateEmailSignatureRequest>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSignatureSignatureId>>,
        TError,
        {signatureId: string;data: BodyType<UpdateEmailSignatureRequest>},
        TContext
      > => {

      const mutationOptions = getPutSignatureSignatureIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete an email signature
 */
export const deleteSignatureSignatureId = (
    signatureId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/signature/${signatureId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteSignatureSignatureIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSignatureSignatureId>>, TError,{signatureId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSignatureSignatureId>>, TError,{signatureId: string}, TContext> => {

const mutationKey = ['deleteSignatureSignatureId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSignatureSignatureId>>, {signatureId: string}> = (props) => {
          const {signatureId} = props ?? {};

          return  deleteSignatureSignatureId(signatureId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSignatureSignatureIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSignatureSignatureId>>>
    
    export type DeleteSignatureSignatureIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete an email signature
 */
export const useDeleteSignatureSignatureId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSignatureSignatureId>>, TError,{signatureId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSignatureSignatureId>>,
        TError,
        {signatureId: string},
        TContext
      > => {

      const mutationOptions = getDeleteSignatureSignatureIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Set an email signature as the default
 */
export const postSignatureSignatureIdSetDefault = (
    signatureId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<EmailSignature>(
      {url: `/signature/${signatureId}/set-default`, method: 'POST', signal
    },
      options);
    }
  


export const getPostSignatureSignatureIdSetDefaultMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSignatureSignatureIdSetDefault>>, TError,{signatureId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postSignatureSignatureIdSetDefault>>, TError,{signatureId: string}, TContext> => {

const mutationKey = ['postSignatureSignatureIdSetDefault'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSignatureSignatureIdSetDefault>>, {signatureId: string}> = (props) => {
          const {signatureId} = props ?? {};

          return  postSignatureSignatureIdSetDefault(signatureId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSignatureSignatureIdSetDefaultMutationResult = NonNullable<Awaited<ReturnType<typeof postSignatureSignatureIdSetDefault>>>
    
    export type PostSignatureSignatureIdSetDefaultMutationError = ErrorType<unknown>

    /**
 * @summary Set an email signature as the default
 */
export const usePostSignatureSignatureIdSetDefault = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSignatureSignatureIdSetDefault>>, TError,{signatureId: string}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSignatureSignatureIdSetDefault>>,
        TError,
        {signatureId: string},
        TContext
      > => {

      const mutationOptions = getPostSignatureSignatureIdSetDefaultMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates a provider bot for the supplied meeting URL and stores entity mapping metadata so the webhook can later create a summary comment on a candidate, job candidate, or job.

 * @summary Join a chatbot notetaker to a meeting
 */
export const postChatbotJoin = (
    postChatbotJoinBody: BodyType<PostChatbotJoinBody>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<ChatbotJoinResponse>(
      {url: `/chatbot/join`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postChatbotJoinBody, signal
    },
      options);
    }
  


export const getPostChatbotJoinMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatbotJoin>>, TError,{data: BodyType<PostChatbotJoinBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatbotJoin>>, TError,{data: BodyType<PostChatbotJoinBody>}, TContext> => {

const mutationKey = ['postChatbotJoin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatbotJoin>>, {data: BodyType<PostChatbotJoinBody>}> = (props) => {
          const {data} = props ?? {};

          return  postChatbotJoin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostChatbotJoinMutationResult = NonNullable<Awaited<ReturnType<typeof postChatbotJoin>>>
    export type PostChatbotJoinMutationBody = BodyType<PostChatbotJoinBody>
    export type PostChatbotJoinMutationError = ErrorType<void>

    /**
 * @summary Join a chatbot notetaker to a meeting
 */
export const usePostChatbotJoin = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatbotJoin>>, TError,{data: BodyType<PostChatbotJoinBody>}, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatbotJoin>>,
        TError,
        {data: BodyType<PostChatbotJoinBody>},
        TContext
      > => {

      const mutationOptions = getPostChatbotJoinMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
